/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 144);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var core = __webpack_require__(21);
var hide = __webpack_require__(14);
var redefine = __webpack_require__(15);
var ctx = __webpack_require__(22);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(7);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
// helper to remove a global reference, which might not be possible via delete alone, depending on the implementation
// of the reference, in that case, fall back to setting the property to undefined
function removeGlobalReference(name) {
	name = '' + name;

	try {
		if (!delete window[name]) {
			window[name] = undefined;
		}
	} catch (ex) {
		window[name] = undefined;
	}
}

// keep these references, they might be directly referenced by other plugins
var jQuery = exports.jQuery = window.$;
var lodash = exports.lodash = window._;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(137);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(53)('wks');
var uid = __webpack_require__(39);
var Symbol = __webpack_require__(3).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(24);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(6)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(1);
var IE8_DOM_DEFINE = __webpack_require__(101);
var toPrimitive = __webpack_require__(27);
var dP = Object.defineProperty;

exports.f = __webpack_require__(10) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(28);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(11);
var createDesc = __webpack_require__(38);
module.exports = __webpack_require__(10) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var hide = __webpack_require__(14);
var has = __webpack_require__(17);
var SRC = __webpack_require__(39)('src');
var $toString = __webpack_require__(149);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(21).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var fails = __webpack_require__(6);
var defined = __webpack_require__(28);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 17 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(54);
var defined = __webpack_require__(28);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(55);
var createDesc = __webpack_require__(38);
var toIObject = __webpack_require__(18);
var toPrimitive = __webpack_require__(27);
var has = __webpack_require__(17);
var IE8_DOM_DEFINE = __webpack_require__(101);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(10) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(17);
var toObject = __webpack_require__(12);
var IE_PROTO = __webpack_require__(75)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 21 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(13);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 23 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 24 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(6);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.AsyncDom = exports.raf = undefined;

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

exports.waitForRepaint = waitForRepaint;

var _shim = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var raf = exports.raf = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.msRequestAnimationFrame || function (callback) {
	return setTimeout(callback, 16);
};

var AsyncDomClass = function () {
	function AsyncDomClass() {
		(0, _classCallCheck3.default)(this, AsyncDomClass);

		this._getStack = [];
		this._setStack = [];
		this._queueRunning = false;
	}

	(0, _createClass3.default)(AsyncDomClass, [{
		key: 'get',
		value: function get(fGet) {
			_shim.jQuery.assert(_shim.jQuery.isFunction(fGet), 'AsyncDomClass.get | fGet is not a function');

			var taskId = _shim.jQuery.randomUuid(true);

			this._getStack.push({
				id: taskId,
				task: fGet
			});
			this.startQueue();

			return taskId;
		}
	}, {
		key: 'set',
		value: function set(fSet) {
			_shim.jQuery.assert(_shim.jQuery.isFunction(fSet), 'AsyncDomClass.set | fSet is not a function');

			var taskId = _shim.jQuery.randomUuid(true);

			this._setStack.push({
				id: taskId,
				task: fSet
			});
			this.startQueue();

			return taskId;
		}
	}, {
		key: 'cancel',
		value: function cancel(taskId) {
			var _this = this;

			var found = false;

			_shim.jQuery.each(this._getStack, function (index, stackItem) {
				if (stackItem.id === taskId) {
					_this._getStack = _shim.jQuery.removeFromArray(_this._getStack, index, index + 1);
					found = true;
					return false;
				}
			});

			if (!found) {
				_shim.jQuery.each(this._setStack, function (index, stackItem) {
					if (stackItem.id === taskId) {
						_this._setStack = _shim.jQuery.removeFromArray(_this._setStack, index, index + 1);
						found = true;
						return false;
					}
				});
			}

			return found;
		}
	}, {
		key: 'startQueue',
		value: function startQueue() {
			var _this2 = this;

			if (!this._queueRunning) {
				this._queueRunning = true;
				raf(function () {
					_this2._runTasks();
				});
			}
		}
	}, {
		key: '_runTasks',
		value: function _runTasks() {
			try {
				var stackItem = void 0;

				while (stackItem = this._getStack.shift()) {
					stackItem.task();
				}

				while (stackItem = this._setStack.shift()) {
					stackItem.task();
				}
			} catch (ex) {
				_shim.jQuery.warn('AsyncDomClass._runTasks | a task errored with "' + ex + '".');
			}

			this._queueRunning = false;
			if (this._getStack.length > 0 || this._setStack.length > 0) {
				this.startQueue();
			}
		}
	}]);
	return AsyncDomClass;
}();

var AsyncDom = exports.AsyncDom = new AsyncDomClass();

function waitForRepaint(callback) {
	raf(function () {
		raf(function () {
			callback();
		});
	});
}

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(7);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 28 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(0);
var core = __webpack_require__(21);
var fails = __webpack_require__(6);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(22);
var IObject = __webpack_require__(54);
var toObject = __webpack_require__(12);
var toLength = __webpack_require__(9);
var asc = __webpack_require__(91);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var BREAKPOINT_MOBILE = exports.BREAKPOINT_MOBILE = 0;
var BREAKPOINT_TABLET = exports.BREAKPOINT_TABLET = 768;
var BREAKPOINT_DESKTOP = exports.BREAKPOINT_DESKTOP = 1025;
var MAX_CONTENT_WIDTH = exports.MAX_CONTENT_WIDTH = 1200;
var IS_IOS_SAFARI = exports.IS_IOS_SAFARI = /iP(ad|od|hone)/i.test(window.navigator.userAgent) && /WebKit/i.test(window.navigator.userAgent) && !/(CriOS|FxiOS|OPiOS|mercury)/i.test(window.navigator.userAgent);
var IS_INTERNET_EXPLORER = exports.IS_INTERNET_EXPLORER = /Trident\//i.test(window.navigator.userAgent);

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(10)) {
  var LIBRARY = __webpack_require__(34);
  var global = __webpack_require__(3);
  var fails = __webpack_require__(6);
  var $export = __webpack_require__(0);
  var $typed = __webpack_require__(68);
  var $buffer = __webpack_require__(99);
  var ctx = __webpack_require__(22);
  var anInstance = __webpack_require__(45);
  var propertyDesc = __webpack_require__(38);
  var hide = __webpack_require__(14);
  var redefineAll = __webpack_require__(47);
  var toInteger = __webpack_require__(24);
  var toLength = __webpack_require__(9);
  var toIndex = __webpack_require__(129);
  var toAbsoluteIndex = __webpack_require__(41);
  var toPrimitive = __webpack_require__(27);
  var has = __webpack_require__(17);
  var classof = __webpack_require__(50);
  var isObject = __webpack_require__(7);
  var toObject = __webpack_require__(12);
  var isArrayIter = __webpack_require__(88);
  var create = __webpack_require__(42);
  var getPrototypeOf = __webpack_require__(20);
  var gOPN = __webpack_require__(43).f;
  var getIterFn = __webpack_require__(90);
  var uid = __webpack_require__(39);
  var wks = __webpack_require__(8);
  var createArrayMethod = __webpack_require__(30);
  var createArrayIncludes = __webpack_require__(58);
  var speciesConstructor = __webpack_require__(57);
  var ArrayIterators = __webpack_require__(93);
  var Iterators = __webpack_require__(52);
  var $iterDetect = __webpack_require__(63);
  var setSpecies = __webpack_require__(44);
  var arrayFill = __webpack_require__(92);
  var arrayCopyWithin = __webpack_require__(118);
  var $DP = __webpack_require__(11);
  var $GOPD = __webpack_require__(19);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(124);
var $export = __webpack_require__(0);
var shared = __webpack_require__(53)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(127))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 34 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(39)('meta');
var isObject = __webpack_require__(7);
var has = __webpack_require__(17);
var setDesc = __webpack_require__(11).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(6)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(8)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(14)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Context = undefined;

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _shim = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContextSingleton = function () {
	function ContextSingleton() {
		(0, _classCallCheck3.default)(this, ContextSingleton);

		this._context = window.CONTEXT;
		if (!_shim.jQuery.isSet(this._context) || !_shim.jQuery.isPlainObject(this._context)) {
			this._context = {};
		}

		this._context = _shim.jQuery.extend({
			debug: false,
			staticBase: '/',
			runningInPatternLab: false,
			runningInIframe: parent !== window,
			isTouchDevice: _shim.jQuery.contextIsTouchDevice(false),
			cookieProConsentLevelForTracking: 2,
			currentCookieProConsentLevel: 1,
			googleTagManagerId: null
		}, this._context);
	}

	//###( ACCESS )###

	(0, _createClass3.default)(ContextSingleton, [{
		key: 'set',
		value: function set(key, value) {
			var force = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

			if (this.has(key) && !force) {
				_shim.jQuery.err('Context | cannot set key that already exits without force parameter');
			} else {
				this._context[key] = value;
			}
		}
	}, {
		key: 'get',
		value: function get(key, defaultVal) {
			if (_shim.jQuery.isSet(key)) {
				defaultVal = _shim.jQuery.orDefault(defaultVal, null);

				return _shim.lodash.get(this._context, key, defaultVal);
			} else {
				return _shim.jQuery.extend({}, this._context);
			}
		}
	}, {
		key: 'has',
		value: function has(key) {
			return _shim.lodash.has(this._context, key);
		}
	}, {
		key: 'remove',
		value: function remove(key) {
			if (this.has(key)) {
				_shim.lodash.unset(this._context, key);
			}
		}

		//###( FUNCTIONALITY )###

	}, {
		key: 'detectPatternlab',
		value: function detectPatternlab() {
			this.set('runningInPatternLab', this._context.runningInPatternLab || (0, _shim.jQuery)('html#patternlab-html').length > 0 || _shim.lodash.startsWith(window.name, 'sg-viewport'), true);

			this.set('runningInPatternLabList', this.get('runningInPatternLab') && _shim.jQuery.exists((0, _shim.jQuery)('#sg-patterns')));

			this.set('runningInPatternLabTemplateOrPage', this.get('runningInPatternLab') && _shim.jQuery.exists((0, _shim.jQuery)('body > main')));

			this.set('runningInPatternLabDetails', this.get('runningInPatternLab') && !this.get('runningInPatternLabList') && !this.get('runningInPatternLabTemplateOrPage'));
		}
	}]);
	return ContextSingleton;
}();

var Context = exports.Context = new ContextSingleton();

/***/ }),
/* 38 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 39 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(103);
var enumBugKeys = __webpack_require__(76);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(24);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(1);
var dPs = __webpack_require__(104);
var enumBugKeys = __webpack_require__(76);
var IE_PROTO = __webpack_require__(75)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(73)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(77).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(103);
var hiddenKeys = __webpack_require__(76).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var dP = __webpack_require__(11);
var DESCRIPTORS = __webpack_require__(10);
var SPECIES = __webpack_require__(8)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 45 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(22);
var call = __webpack_require__(116);
var isArrayIter = __webpack_require__(88);
var anObject = __webpack_require__(1);
var toLength = __webpack_require__(9);
var getIterFn = __webpack_require__(90);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(15);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(7);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(11).f;
var has = __webpack_require__(17);
var TAG = __webpack_require__(8)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(23);
var TAG = __webpack_require__(8)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var defined = __webpack_require__(28);
var fails = __webpack_require__(6);
var spaces = __webpack_require__(79);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 52 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(21);
var global = __webpack_require__(3);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(34) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(23);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 55 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(1);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(1);
var aFunction = __webpack_require__(13);
var SPECIES = __webpack_require__(8)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(18);
var toLength = __webpack_require__(9);
var toAbsoluteIndex = __webpack_require__(41);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 59 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(23);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(24);
var defined = __webpack_require__(28);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(7);
var cof = __webpack_require__(23);
var MATCH = __webpack_require__(8)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(8)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__(50);
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(120);
var redefine = __webpack_require__(15);
var hide = __webpack_require__(14);
var fails = __webpack_require__(6);
var defined = __webpack_require__(28);
var wks = __webpack_require__(8);
var regexpExec = __webpack_require__(94);

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(15);
var redefineAll = __webpack_require__(47);
var meta = __webpack_require__(35);
var forOf = __webpack_require__(46);
var anInstance = __webpack_require__(45);
var isObject = __webpack_require__(7);
var fails = __webpack_require__(6);
var $iterDetect = __webpack_require__(63);
var setToStringTag = __webpack_require__(49);
var inheritIfRequired = __webpack_require__(80);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var hide = __webpack_require__(14);
var uid = __webpack_require__(39);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(34) || !__webpack_require__(6)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(3)[K];
});


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(0);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(0);
var aFunction = __webpack_require__(13);
var ctx = __webpack_require__(22);
var forOf = __webpack_require__(46);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(141)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(7);
var document = __webpack_require__(3).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var core = __webpack_require__(21);
var LIBRARY = __webpack_require__(34);
var wksExt = __webpack_require__(102);
var defineProperty = __webpack_require__(11).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(53)('keys');
var uid = __webpack_require__(39);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 76 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(3).document;
module.exports = document && document.documentElement;


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(7);
var anObject = __webpack_require__(1);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(22)(Function.call, __webpack_require__(19).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 79 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(7);
var setPrototypeOf = __webpack_require__(78).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(24);
var defined = __webpack_require__(28);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 82 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 83 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(34);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(15);
var hide = __webpack_require__(14);
var Iterators = __webpack_require__(52);
var $iterCreate = __webpack_require__(85);
var setToStringTag = __webpack_require__(49);
var getPrototypeOf = __webpack_require__(20);
var ITERATOR = __webpack_require__(8)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(42);
var descriptor = __webpack_require__(38);
var setToStringTag = __webpack_require__(49);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(14)(IteratorPrototype, __webpack_require__(8)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(62);
var defined = __webpack_require__(28);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(8)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(52);
var ITERATOR = __webpack_require__(8)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(11);
var createDesc = __webpack_require__(38);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(50);
var ITERATOR = __webpack_require__(8)('iterator');
var Iterators = __webpack_require__(52);
module.exports = __webpack_require__(21).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(238);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(12);
var toAbsoluteIndex = __webpack_require__(41);
var toLength = __webpack_require__(9);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(36);
var step = __webpack_require__(119);
var Iterators = __webpack_require__(52);
var toIObject = __webpack_require__(18);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(84)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__(56);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__(61)(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(22);
var invoke = __webpack_require__(109);
var html = __webpack_require__(77);
var cel = __webpack_require__(73);
var global = __webpack_require__(3);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(23)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var macrotask = __webpack_require__(96).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(23)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(13);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var DESCRIPTORS = __webpack_require__(10);
var LIBRARY = __webpack_require__(34);
var $typed = __webpack_require__(68);
var hide = __webpack_require__(14);
var redefineAll = __webpack_require__(47);
var fails = __webpack_require__(6);
var anInstance = __webpack_require__(45);
var toInteger = __webpack_require__(24);
var toLength = __webpack_require__(9);
var toIndex = __webpack_require__(129);
var gOPN = __webpack_require__(43).f;
var dP = __webpack_require__(11).f;
var arrayFill = __webpack_require__(92);
var setToStringTag = __webpack_require__(49);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 100 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(10) && !__webpack_require__(6)(function () {
  return Object.defineProperty(__webpack_require__(73)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(8);


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(17);
var toIObject = __webpack_require__(18);
var arrayIndexOf = __webpack_require__(58)(false);
var IE_PROTO = __webpack_require__(75)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(11);
var anObject = __webpack_require__(1);
var getKeys = __webpack_require__(40);

module.exports = __webpack_require__(10) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(18);
var gOPN = __webpack_require__(43).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(10);
var getKeys = __webpack_require__(40);
var gOPS = __webpack_require__(59);
var pIE = __webpack_require__(55);
var toObject = __webpack_require__(12);
var IObject = __webpack_require__(54);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(6)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 107 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(13);
var isObject = __webpack_require__(7);
var invoke = __webpack_require__(109);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 109 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(3).parseInt;
var $trim = __webpack_require__(51).trim;
var ws = __webpack_require__(79);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(3).parseFloat;
var $trim = __webpack_require__(51).trim;

module.exports = 1 / $parseFloat(__webpack_require__(79) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(23);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(7);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 114 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(82);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(1);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(13);
var toObject = __webpack_require__(12);
var IObject = __webpack_require__(54);
var toLength = __webpack_require__(9);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(12);
var toAbsoluteIndex = __webpack_require__(41);
var toLength = __webpack_require__(9);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 119 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__(94);
__webpack_require__(0)({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(10) && /./g.flags != 'g') __webpack_require__(11).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(56)
});


/***/ }),
/* 122 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(1);
var isObject = __webpack_require__(7);
var newPromiseCapability = __webpack_require__(98);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(125);
var validate = __webpack_require__(48);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(67)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(11).f;
var create = __webpack_require__(42);
var redefineAll = __webpack_require__(47);
var ctx = __webpack_require__(22);
var anInstance = __webpack_require__(45);
var forOf = __webpack_require__(46);
var $iterDefine = __webpack_require__(84);
var step = __webpack_require__(119);
var setSpecies = __webpack_require__(44);
var DESCRIPTORS = __webpack_require__(10);
var fastKey = __webpack_require__(35).fastKey;
var validate = __webpack_require__(48);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(125);
var validate = __webpack_require__(48);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(67)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var each = __webpack_require__(30)(0);
var redefine = __webpack_require__(15);
var meta = __webpack_require__(35);
var assign = __webpack_require__(106);
var weak = __webpack_require__(128);
var isObject = __webpack_require__(7);
var validate = __webpack_require__(48);
var NATIVE_WEAK_MAP = __webpack_require__(48);
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(67)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(47);
var getWeak = __webpack_require__(35).getWeak;
var anObject = __webpack_require__(1);
var isObject = __webpack_require__(7);
var anInstance = __webpack_require__(45);
var forOf = __webpack_require__(46);
var createArrayMethod = __webpack_require__(30);
var $has = __webpack_require__(17);
var validate = __webpack_require__(48);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(24);
var toLength = __webpack_require__(9);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(43);
var gOPS = __webpack_require__(59);
var anObject = __webpack_require__(1);
var Reflect = __webpack_require__(3).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(60);
var isObject = __webpack_require__(7);
var toLength = __webpack_require__(9);
var ctx = __webpack_require__(22);
var IS_CONCAT_SPREADABLE = __webpack_require__(8)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(9);
var repeat = __webpack_require__(81);
var defined = __webpack_require__(28);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(10);
var getKeys = __webpack_require__(40);
var toIObject = __webpack_require__(18);
var isEnum = __webpack_require__(55).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(50);
var from = __webpack_require__(135);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(46);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 136 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(349), __esModule: true };

/***/ }),
/* 138 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 139 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(355);
var IE8_DOM_DEFINE = __webpack_require__(356);
var toPrimitive = __webpack_require__(358);
var dP = Object.defineProperty;

exports.f = __webpack_require__(72) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 141 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.generateObjectFitCallback = generateObjectFitCallback;

var _shim = __webpack_require__(2);

function generateObjectFitCallback(config) {
	_shim.jQuery.assert(_shim.jQuery.hasMembers(config, ['callbackHandler', '$element', 'containerSelector']), 'generateObjectFitCallback | missing config (callbackHandler, $element or containerSelector)');

	var callbackHandler = config.callbackHandler,
	    $element = config.$element,
	    containerSelector = '' + config.containerSelector,
	    $container = $element.closest(containerSelector),
	    positioningSelector = _shim.jQuery.isSet(config.positioningSelector) ? '' + config.positioningSelector : null,
	    $positioningElement = _shim.jQuery.isSet(positioningSelector) ? $element.closest(positioningSelector) : $element,
	    containerWidth = null,
	    containerHeight = null,
	    containerAr = null,
	    elementWidth = null,
	    elementHeight = null,
	    elementAr = null,
	    elementFits = false,
	    elementPosition = _shim.jQuery.isSet(config.position) ? config.position : { 'top': '50%', 'left': '50%' };

	$element.css({
		'max-width': 'none',
		'max-height': 'none'
	});

	$positioningElement.css(_shim.jQuery.extend({
		'position': 'absolute',
		'max-width': 'none',
		'max-height': 'none'
	}, elementPosition));

	if ((elementPosition.top === '50%' || elementPosition.bottom === '50%') && (elementPosition.left === '50%' || elementPosition.right === '50%')) {
		$positioningElement.cssCrossBrowser({
			'transform': 'translate(-50%, -50%)'
		});
	} else if (elementPosition.top === '50%' || elementPosition.bottom === '50%') {
		$positioningElement.cssCrossBrowser({
			'transform': 'translateY(-50%)'
		});
	} else if (elementPosition.left === '50%' || elementPosition.right === '50%') {
		$positioningElement.cssCrossBrowser({
			'transform': 'translateX(-50%)'
		});
	}

	return callbackHandler(function () {
		elementWidth = $element.outerWidth();
		elementHeight = $element.outerHeight();

		containerWidth = $container.outerWidth();
		containerHeight = $container.outerHeight();

		elementFits = elementWidth === containerWidth && elementHeight >= containerHeight || elementHeight === containerHeight && elementWidth >= containerWidth;

		if (!elementFits) {
			containerAr = containerWidth / containerHeight;
			elementAr = elementWidth / elementHeight;

			if (elementAr >= containerAr) {
				$element.css({
					'width': '',
					'height': containerHeight
				});
			} else {
				$element.css({
					'width': containerWidth,
					'height': ''
				});
			}
		}
	});
}

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(137);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(145);
module.exports = __webpack_require__(348);


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(147);

__webpack_require__(344);

__webpack_require__(345);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(146)))

/***/ }),
/* 146 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(148);
__webpack_require__(151);
__webpack_require__(152);
__webpack_require__(153);
__webpack_require__(154);
__webpack_require__(155);
__webpack_require__(156);
__webpack_require__(157);
__webpack_require__(158);
__webpack_require__(159);
__webpack_require__(160);
__webpack_require__(161);
__webpack_require__(162);
__webpack_require__(163);
__webpack_require__(164);
__webpack_require__(165);
__webpack_require__(166);
__webpack_require__(167);
__webpack_require__(168);
__webpack_require__(169);
__webpack_require__(170);
__webpack_require__(171);
__webpack_require__(172);
__webpack_require__(173);
__webpack_require__(174);
__webpack_require__(175);
__webpack_require__(176);
__webpack_require__(177);
__webpack_require__(178);
__webpack_require__(179);
__webpack_require__(180);
__webpack_require__(181);
__webpack_require__(182);
__webpack_require__(183);
__webpack_require__(184);
__webpack_require__(185);
__webpack_require__(186);
__webpack_require__(187);
__webpack_require__(188);
__webpack_require__(189);
__webpack_require__(190);
__webpack_require__(191);
__webpack_require__(192);
__webpack_require__(193);
__webpack_require__(194);
__webpack_require__(195);
__webpack_require__(196);
__webpack_require__(197);
__webpack_require__(198);
__webpack_require__(199);
__webpack_require__(200);
__webpack_require__(201);
__webpack_require__(202);
__webpack_require__(203);
__webpack_require__(204);
__webpack_require__(205);
__webpack_require__(206);
__webpack_require__(207);
__webpack_require__(208);
__webpack_require__(209);
__webpack_require__(210);
__webpack_require__(211);
__webpack_require__(212);
__webpack_require__(213);
__webpack_require__(214);
__webpack_require__(215);
__webpack_require__(216);
__webpack_require__(217);
__webpack_require__(218);
__webpack_require__(219);
__webpack_require__(220);
__webpack_require__(221);
__webpack_require__(222);
__webpack_require__(223);
__webpack_require__(224);
__webpack_require__(225);
__webpack_require__(226);
__webpack_require__(228);
__webpack_require__(229);
__webpack_require__(231);
__webpack_require__(232);
__webpack_require__(233);
__webpack_require__(234);
__webpack_require__(235);
__webpack_require__(236);
__webpack_require__(237);
__webpack_require__(239);
__webpack_require__(240);
__webpack_require__(241);
__webpack_require__(242);
__webpack_require__(243);
__webpack_require__(244);
__webpack_require__(245);
__webpack_require__(246);
__webpack_require__(247);
__webpack_require__(248);
__webpack_require__(249);
__webpack_require__(250);
__webpack_require__(251);
__webpack_require__(93);
__webpack_require__(252);
__webpack_require__(120);
__webpack_require__(253);
__webpack_require__(121);
__webpack_require__(254);
__webpack_require__(255);
__webpack_require__(256);
__webpack_require__(257);
__webpack_require__(258);
__webpack_require__(124);
__webpack_require__(126);
__webpack_require__(127);
__webpack_require__(259);
__webpack_require__(260);
__webpack_require__(261);
__webpack_require__(262);
__webpack_require__(263);
__webpack_require__(264);
__webpack_require__(265);
__webpack_require__(266);
__webpack_require__(267);
__webpack_require__(268);
__webpack_require__(269);
__webpack_require__(270);
__webpack_require__(271);
__webpack_require__(272);
__webpack_require__(273);
__webpack_require__(274);
__webpack_require__(275);
__webpack_require__(276);
__webpack_require__(277);
__webpack_require__(278);
__webpack_require__(279);
__webpack_require__(280);
__webpack_require__(281);
__webpack_require__(282);
__webpack_require__(283);
__webpack_require__(284);
__webpack_require__(285);
__webpack_require__(286);
__webpack_require__(287);
__webpack_require__(288);
__webpack_require__(289);
__webpack_require__(290);
__webpack_require__(291);
__webpack_require__(292);
__webpack_require__(293);
__webpack_require__(294);
__webpack_require__(295);
__webpack_require__(296);
__webpack_require__(297);
__webpack_require__(298);
__webpack_require__(299);
__webpack_require__(300);
__webpack_require__(301);
__webpack_require__(302);
__webpack_require__(303);
__webpack_require__(304);
__webpack_require__(305);
__webpack_require__(306);
__webpack_require__(307);
__webpack_require__(308);
__webpack_require__(309);
__webpack_require__(310);
__webpack_require__(311);
__webpack_require__(312);
__webpack_require__(313);
__webpack_require__(314);
__webpack_require__(315);
__webpack_require__(316);
__webpack_require__(317);
__webpack_require__(318);
__webpack_require__(319);
__webpack_require__(320);
__webpack_require__(321);
__webpack_require__(322);
__webpack_require__(323);
__webpack_require__(324);
__webpack_require__(325);
__webpack_require__(326);
__webpack_require__(327);
__webpack_require__(328);
__webpack_require__(329);
__webpack_require__(330);
__webpack_require__(331);
__webpack_require__(332);
__webpack_require__(333);
__webpack_require__(334);
__webpack_require__(335);
__webpack_require__(336);
__webpack_require__(337);
__webpack_require__(338);
__webpack_require__(339);
__webpack_require__(340);
__webpack_require__(341);
__webpack_require__(342);
__webpack_require__(343);
module.exports = __webpack_require__(21);


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(3);
var has = __webpack_require__(17);
var DESCRIPTORS = __webpack_require__(10);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(15);
var META = __webpack_require__(35).KEY;
var $fails = __webpack_require__(6);
var shared = __webpack_require__(53);
var setToStringTag = __webpack_require__(49);
var uid = __webpack_require__(39);
var wks = __webpack_require__(8);
var wksExt = __webpack_require__(102);
var wksDefine = __webpack_require__(74);
var enumKeys = __webpack_require__(150);
var isArray = __webpack_require__(60);
var anObject = __webpack_require__(1);
var isObject = __webpack_require__(7);
var toObject = __webpack_require__(12);
var toIObject = __webpack_require__(18);
var toPrimitive = __webpack_require__(27);
var createDesc = __webpack_require__(38);
var _create = __webpack_require__(42);
var gOPNExt = __webpack_require__(105);
var $GOPD = __webpack_require__(19);
var $GOPS = __webpack_require__(59);
var $DP = __webpack_require__(11);
var $keys = __webpack_require__(40);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(43).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(55).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(34)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(14)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(53)('native-function-to-string', Function.toString);


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(40);
var gOPS = __webpack_require__(59);
var pIE = __webpack_require__(55);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(42) });


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(10), 'Object', { defineProperty: __webpack_require__(11).f });


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(10), 'Object', { defineProperties: __webpack_require__(104) });


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(18);
var $getOwnPropertyDescriptor = __webpack_require__(19).f;

__webpack_require__(29)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(12);
var $getPrototypeOf = __webpack_require__(20);

__webpack_require__(29)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(12);
var $keys = __webpack_require__(40);

__webpack_require__(29)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(29)('getOwnPropertyNames', function () {
  return __webpack_require__(105).f;
});


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(7);
var meta = __webpack_require__(35).onFreeze;

__webpack_require__(29)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(7);
var meta = __webpack_require__(35).onFreeze;

__webpack_require__(29)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(7);
var meta = __webpack_require__(35).onFreeze;

__webpack_require__(29)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(7);

__webpack_require__(29)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(7);

__webpack_require__(29)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(7);

__webpack_require__(29)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(0);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(106) });


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(0);
$export($export.S, 'Object', { is: __webpack_require__(107) });


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(0);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(78).set });


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(50);
var test = {};
test[__webpack_require__(8)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(15)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(0);

$export($export.P, 'Function', { bind: __webpack_require__(108) });


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(11).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(10) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(7);
var getPrototypeOf = __webpack_require__(20);
var HAS_INSTANCE = __webpack_require__(8)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(11).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseInt = __webpack_require__(110);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseFloat = __webpack_require__(111);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var has = __webpack_require__(17);
var cof = __webpack_require__(23);
var inheritIfRequired = __webpack_require__(80);
var toPrimitive = __webpack_require__(27);
var fails = __webpack_require__(6);
var gOPN = __webpack_require__(43).f;
var gOPD = __webpack_require__(19).f;
var dP = __webpack_require__(11).f;
var $trim = __webpack_require__(51).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(42)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(10) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(15)(global, NUMBER, $Number);
}


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toInteger = __webpack_require__(24);
var aNumberValue = __webpack_require__(112);
var repeat = __webpack_require__(81);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(6)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $fails = __webpack_require__(6);
var aNumberValue = __webpack_require__(112);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(0);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(0);
var _isFinite = __webpack_require__(3).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', { isInteger: __webpack_require__(113) });


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(0);
var isInteger = __webpack_require__(113);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseFloat = __webpack_require__(111);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseInt = __webpack_require__(110);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(0);
var log1p = __webpack_require__(114);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(0);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(0);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(0);
var sign = __webpack_require__(82);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(0);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(0);
var $expm1 = __webpack_require__(83);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { fround: __webpack_require__(115) });


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(0);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(0);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(6)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { log1p: __webpack_require__(114) });


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { sign: __webpack_require__(82) });


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(0);
var expm1 = __webpack_require__(83);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(6)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(0);
var expm1 = __webpack_require__(83);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var toAbsoluteIndex = __webpack_require__(41);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var toIObject = __webpack_require__(18);
var toLength = __webpack_require__(9);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(51)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(61)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(84)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $at = __webpack_require__(61)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(0);
var toLength = __webpack_require__(9);
var context = __webpack_require__(86);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(87)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(0);
var context = __webpack_require__(86);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(87)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(81)
});


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(0);
var toLength = __webpack_require__(9);
var context = __webpack_require__(86);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(87)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(16)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(16)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(16)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(16)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(16)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(16)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(16)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(16)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(16)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(16)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(16)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(16)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(16)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(0);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(12);
var toPrimitive = __webpack_require__(27);

$export($export.P + $export.F * __webpack_require__(6)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(0);
var toISOString = __webpack_require__(227);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(6);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(15)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(8)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(14)(proto, TO_PRIMITIVE, __webpack_require__(230));


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(1);
var toPrimitive = __webpack_require__(27);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(0);

$export($export.S, 'Array', { isArray: __webpack_require__(60) });


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(22);
var $export = __webpack_require__(0);
var toObject = __webpack_require__(12);
var call = __webpack_require__(116);
var isArrayIter = __webpack_require__(88);
var toLength = __webpack_require__(9);
var createProperty = __webpack_require__(89);
var getIterFn = __webpack_require__(90);

$export($export.S + $export.F * !__webpack_require__(63)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var createProperty = __webpack_require__(89);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(6)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(0);
var toIObject = __webpack_require__(18);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(54) != Object || !__webpack_require__(25)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var html = __webpack_require__(77);
var cof = __webpack_require__(23);
var toAbsoluteIndex = __webpack_require__(41);
var toLength = __webpack_require__(9);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(6)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var aFunction = __webpack_require__(13);
var toObject = __webpack_require__(12);
var fails = __webpack_require__(6);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(25)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $forEach = __webpack_require__(30)(0);
var STRICT = __webpack_require__(25)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(7);
var isArray = __webpack_require__(60);
var SPECIES = __webpack_require__(8)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $map = __webpack_require__(30)(1);

$export($export.P + $export.F * !__webpack_require__(25)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $filter = __webpack_require__(30)(2);

$export($export.P + $export.F * !__webpack_require__(25)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $some = __webpack_require__(30)(3);

$export($export.P + $export.F * !__webpack_require__(25)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $every = __webpack_require__(30)(4);

$export($export.P + $export.F * !__webpack_require__(25)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $reduce = __webpack_require__(117);

$export($export.P + $export.F * !__webpack_require__(25)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $reduce = __webpack_require__(117);

$export($export.P + $export.F * !__webpack_require__(25)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $indexOf = __webpack_require__(58)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(25)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toIObject = __webpack_require__(18);
var toInteger = __webpack_require__(24);
var toLength = __webpack_require__(9);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(25)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', { copyWithin: __webpack_require__(118) });

__webpack_require__(36)('copyWithin');


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', { fill: __webpack_require__(92) });

__webpack_require__(36)('fill');


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(0);
var $find = __webpack_require__(30)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(36)(KEY);


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(0);
var $find = __webpack_require__(30)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(36)(KEY);


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(44)('Array');


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var inheritIfRequired = __webpack_require__(80);
var dP = __webpack_require__(11).f;
var gOPN = __webpack_require__(43).f;
var isRegExp = __webpack_require__(62);
var $flags = __webpack_require__(56);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(10) && (!CORRECT_NEW || __webpack_require__(6)(function () {
  re2[__webpack_require__(8)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(15)(global, 'RegExp', $RegExp);
}

__webpack_require__(44)('RegExp');


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(121);
var anObject = __webpack_require__(1);
var $flags = __webpack_require__(56);
var DESCRIPTORS = __webpack_require__(10);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(15)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(6)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(1);
var toLength = __webpack_require__(9);
var advanceStringIndex = __webpack_require__(95);
var regExpExec = __webpack_require__(64);

// @@match logic
__webpack_require__(65)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(1);
var toObject = __webpack_require__(12);
var toLength = __webpack_require__(9);
var toInteger = __webpack_require__(24);
var advanceStringIndex = __webpack_require__(95);
var regExpExec = __webpack_require__(64);
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__(65)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(1);
var sameValue = __webpack_require__(107);
var regExpExec = __webpack_require__(64);

// @@search logic
__webpack_require__(65)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__(62);
var anObject = __webpack_require__(1);
var speciesConstructor = __webpack_require__(57);
var advanceStringIndex = __webpack_require__(95);
var toLength = __webpack_require__(9);
var callRegExpExec = __webpack_require__(64);
var regexpExec = __webpack_require__(94);
var fails = __webpack_require__(6);
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__(65)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(34);
var global = __webpack_require__(3);
var ctx = __webpack_require__(22);
var classof = __webpack_require__(50);
var $export = __webpack_require__(0);
var isObject = __webpack_require__(7);
var aFunction = __webpack_require__(13);
var anInstance = __webpack_require__(45);
var forOf = __webpack_require__(46);
var speciesConstructor = __webpack_require__(57);
var task = __webpack_require__(96).set;
var microtask = __webpack_require__(97)();
var newPromiseCapabilityModule = __webpack_require__(98);
var perform = __webpack_require__(122);
var userAgent = __webpack_require__(66);
var promiseResolve = __webpack_require__(123);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(8)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(47)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(49)($Promise, PROMISE);
__webpack_require__(44)(PROMISE);
Wrapper = __webpack_require__(21)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(63)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(128);
var validate = __webpack_require__(48);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(67)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $typed = __webpack_require__(68);
var buffer = __webpack_require__(99);
var anObject = __webpack_require__(1);
var toAbsoluteIndex = __webpack_require__(41);
var toLength = __webpack_require__(9);
var isObject = __webpack_require__(7);
var ArrayBuffer = __webpack_require__(3).ArrayBuffer;
var speciesConstructor = __webpack_require__(57);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(6)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(44)(ARRAY_BUFFER);


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
$export($export.G + $export.W + $export.F * !__webpack_require__(68).ABV, {
  DataView: __webpack_require__(99).DataView
});


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(32)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(32)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(32)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(32)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(32)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(32)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(32)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(32)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(32)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(0);
var aFunction = __webpack_require__(13);
var anObject = __webpack_require__(1);
var rApply = (__webpack_require__(3).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(6)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(0);
var create = __webpack_require__(42);
var aFunction = __webpack_require__(13);
var anObject = __webpack_require__(1);
var isObject = __webpack_require__(7);
var fails = __webpack_require__(6);
var bind = __webpack_require__(108);
var rConstruct = (__webpack_require__(3).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(11);
var $export = __webpack_require__(0);
var anObject = __webpack_require__(1);
var toPrimitive = __webpack_require__(27);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(6)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(0);
var gOPD = __webpack_require__(19).f;
var anObject = __webpack_require__(1);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(1);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(85)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(19);
var getPrototypeOf = __webpack_require__(20);
var has = __webpack_require__(17);
var $export = __webpack_require__(0);
var isObject = __webpack_require__(7);
var anObject = __webpack_require__(1);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(19);
var $export = __webpack_require__(0);
var anObject = __webpack_require__(1);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(0);
var getProto = __webpack_require__(20);
var anObject = __webpack_require__(1);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(1);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(130) });


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(1);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(11);
var gOPD = __webpack_require__(19);
var getPrototypeOf = __webpack_require__(20);
var has = __webpack_require__(17);
var $export = __webpack_require__(0);
var createDesc = __webpack_require__(38);
var anObject = __webpack_require__(1);
var isObject = __webpack_require__(7);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(0);
var setProto = __webpack_require__(78);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(0);
var $includes = __webpack_require__(58)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(36)('includes');


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(0);
var flattenIntoArray = __webpack_require__(131);
var toObject = __webpack_require__(12);
var toLength = __webpack_require__(9);
var aFunction = __webpack_require__(13);
var arraySpeciesCreate = __webpack_require__(91);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(36)('flatMap');


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(0);
var flattenIntoArray = __webpack_require__(131);
var toObject = __webpack_require__(12);
var toLength = __webpack_require__(9);
var toInteger = __webpack_require__(24);
var arraySpeciesCreate = __webpack_require__(91);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(36)('flatten');


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(0);
var $at = __webpack_require__(61)(true);
var $fails = __webpack_require__(6);

var FORCED = $fails(function () {
  return '𠮷'.at(0) !== '𠮷';
});

$export($export.P + $export.F * FORCED, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(0);
var $pad = __webpack_require__(132);
var userAgent = __webpack_require__(66);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(0);
var $pad = __webpack_require__(132);
var userAgent = __webpack_require__(66);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(51)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(51)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(0);
var defined = __webpack_require__(28);
var toLength = __webpack_require__(9);
var isRegExp = __webpack_require__(62);
var getFlags = __webpack_require__(56);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(85)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(74)('asyncIterator');


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(74)('observable');


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(0);
var ownKeys = __webpack_require__(130);
var toIObject = __webpack_require__(18);
var gOPD = __webpack_require__(19);
var createProperty = __webpack_require__(89);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(0);
var $values = __webpack_require__(133)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(0);
var $entries = __webpack_require__(133)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(12);
var aFunction = __webpack_require__(13);
var $defineProperty = __webpack_require__(11);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(10) && $export($export.P + __webpack_require__(69), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(12);
var aFunction = __webpack_require__(13);
var $defineProperty = __webpack_require__(11);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(10) && $export($export.P + __webpack_require__(69), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(12);
var toPrimitive = __webpack_require__(27);
var getPrototypeOf = __webpack_require__(20);
var getOwnPropertyDescriptor = __webpack_require__(19).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(10) && $export($export.P + __webpack_require__(69), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(12);
var toPrimitive = __webpack_require__(27);
var getPrototypeOf = __webpack_require__(20);
var getOwnPropertyDescriptor = __webpack_require__(19).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(10) && $export($export.P + __webpack_require__(69), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(0);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(134)('Map') });


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(0);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(134)('Set') });


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(70)('Map');


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(70)('Set');


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(70)('WeakMap');


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(70)('WeakSet');


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(71)('Map');


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(71)('Set');


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(71)('WeakMap');


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(71)('WeakSet');


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(0);

$export($export.G, { global: __webpack_require__(3) });


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(0);

$export($export.S, 'System', { global: __webpack_require__(3) });


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(0);
var cof = __webpack_require__(23);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var scale = __webpack_require__(136);
var fround = __webpack_require__(115);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { scale: __webpack_require__(136) });


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(0);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(0);
var core = __webpack_require__(21);
var global = __webpack_require__(3);
var speciesConstructor = __webpack_require__(57);
var promiseResolve = __webpack_require__(123);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(0);
var newPromiseCapability = __webpack_require__(98);
var perform = __webpack_require__(122);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(33);
var anObject = __webpack_require__(1);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(33);
var anObject = __webpack_require__(1);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(33);
var anObject = __webpack_require__(1);
var getPrototypeOf = __webpack_require__(20);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(126);
var from = __webpack_require__(135);
var metadata = __webpack_require__(33);
var anObject = __webpack_require__(1);
var getPrototypeOf = __webpack_require__(20);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(33);
var anObject = __webpack_require__(1);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(33);
var anObject = __webpack_require__(1);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(33);
var anObject = __webpack_require__(1);
var getPrototypeOf = __webpack_require__(20);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(33);
var anObject = __webpack_require__(1);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(33);
var anObject = __webpack_require__(1);
var aFunction = __webpack_require__(13);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(0);
var microtask = __webpack_require__(97)();
var process = __webpack_require__(3).process;
var isNode = __webpack_require__(23)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(0);
var global = __webpack_require__(3);
var core = __webpack_require__(21);
var microtask = __webpack_require__(97)();
var OBSERVABLE = __webpack_require__(8)('observable');
var aFunction = __webpack_require__(13);
var anObject = __webpack_require__(1);
var anInstance = __webpack_require__(45);
var redefineAll = __webpack_require__(47);
var hide = __webpack_require__(14);
var forOf = __webpack_require__(46);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(44)('Observable');


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(3);
var $export = __webpack_require__(0);
var userAgent = __webpack_require__(66);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $task = __webpack_require__(96);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(93);
var getKeys = __webpack_require__(40);
var redefine = __webpack_require__(15);
var global = __webpack_require__(3);
var hide = __webpack_require__(14);
var Iterators = __webpack_require__(52);
var wks = __webpack_require__(8);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 344 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(346);
module.exports = __webpack_require__(21).RegExp.escape;


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(0);
var $re = __webpack_require__(347)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 347 */
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.App = undefined;

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _shim = __webpack_require__(2);

var _context = __webpack_require__(37);

var _defines = __webpack_require__(31);

var _header = __webpack_require__(361);

var _footer = __webpack_require__(364);

var _contactPanel = __webpack_require__(365);

var _stickyPageUp = __webpack_require__(366);

var _privacyLayer = __webpack_require__(367);

var _messageOverlay = __webpack_require__(368);

var _select = __webpack_require__(369);

var _checkbox = __webpack_require__(370);

var _radiobutton = __webpack_require__(371);

var _textinput = __webpack_require__(372);

var _textarea = __webpack_require__(373);

var _inPageNavigation = __webpack_require__(374);

var _dViewer = __webpack_require__(375);

var _video = __webpack_require__(376);

var _googleMap = __webpack_require__(377);

var _headerImage = __webpack_require__(378);

var _headerImageHomepage = __webpack_require__(379);

var _teaser3Columns = __webpack_require__(380);

var _tabContentsliderImageTextLink = __webpack_require__(381);

var _productTeaserList = __webpack_require__(382);

var _teaserslider4columns = __webpack_require__(383);

var _imageFullwidthTextbox = __webpack_require__(384);

var _keyFigures = __webpack_require__(385);

var _verticalTabsTextImage = __webpack_require__(386);

var _collapsible = __webpack_require__(387);

var _breakoutImageTabTeaser = __webpack_require__(388);

var _productIntro = __webpack_require__(389);

var _filterbox3Columns = __webpack_require__(390);

var _filteredDownloadList = __webpack_require__(391);

var _filterboxLocations = __webpack_require__(392);

var _filteredLocationList = __webpack_require__(393);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//###[ IMPORTS ]########################################################################################################

function initOrganisms(app) {
	(0, _header.init)(app);
	(0, _footer.init)(app);
	(0, _stickyPageUp.init)(app);
	(0, _privacyLayer.init)(app);
	(0, _messageOverlay.init)(app);

	(0, _select.init)(app);
	(0, _checkbox.init)(app);
	(0, _radiobutton.init)(app);
	(0, _textinput.init)(app);
	(0, _textarea.init)(app);

	(0, _inPageNavigation.init)(app);
	(0, _dViewer.init)(app);
	(0, _video.init)(app);
	(0, _googleMap.init)(app);
	(0, _headerImage.init)(app);

	(0, _headerImageHomepage.init)(app);
	(0, _teaser3Columns.init)(app);
	(0, _tabContentsliderImageTextLink.init)(app);
	(0, _productTeaserList.init)(app);
	(0, _teaserslider4columns.init)(app);
	(0, _keyFigures.init)(app);
	(0, _imageFullwidthTextbox.init)(app);
	(0, _verticalTabsTextImage.init)(app);
	(0, _collapsible.init)(app);
	(0, _breakoutImageTabTeaser.init)(app);
	(0, _productIntro.init)(app);
	(0, _contactPanel.init)(app);
	(0, _filterbox3Columns.init)(app);
	(0, _filteredDownloadList.init)(app);
	(0, _filterboxLocations.init)(app);
	(0, _filteredLocationList.init)(app);
}

//###[ CONSTANTS ]######################################################################################################

//###[ ORGANISMS INIT ]#################################################################################################

var TARGET_FPS = 30,
    FUZZY_TARGET_FPS = 4;

//###[ SHIV ]##########################################################################################################

var requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;

var cancelAnimationFrame = window.cancelAnimationFrame || window.mozCancelAnimationFrame;

//###[ APP ]########################################################################################################

var App = exports.App = function () {
	function App() {
		var _this = this;

		(0, _classCallCheck3.default)(this, App);

		_context.Context.detectPatternlab();

		this._$html = (0, _shim.jQuery)('html').first();
		this._$body = this._$html.find('body').first();

		this._$html.addClass('ready');
		(0, _shim.jQuery)(window).one('load', function () {
			_this._$html.addClass('loaded');
		});

		if (_context.Context.get('isTouchDevice')) {
			this._$html.addClass('touch');
		}

		if (_context.Context.get('runningInIframe')) {
			this._$html.addClass('is-in-iframe');
		}

		if (_context.Context.get('runningInPatternLab')) {
			this._$html.addClass('is-pattern');

			if (window.parent) {
				var sgHeader = window.parent.document.getElementsByClassName('sg-header');

				if (sgHeader.length > 0) {
					sgHeader[0].style.background = 'rgba(0, 0, 0, 0.75)';
				}
			}
		}

		if (_context.Context.get('runningInPatternLabList')) {
			this._$html.addClass('is-pattern-list');
		}

		if (_context.Context.get('runningInPatternLabDetails')) {
			this._$html.addClass('is-pattern-details');
		}

		if (_context.Context.get('runningInPatternLabTemplateOrPage')) {
			this._$html.addClass('is-pattern-template-or-page');
		}

		// Deactivate console logging in production
		if (!_context.Context.get('debug')) {
			_shim.jQuery.log().disable();
		}

		_shim.jQuery.log('###( Witzenmann app started )###');
		_shim.jQuery.log('###> Context:', _context.Context.get());

		this._updateLoop = null;
		this._updateLoopCallbacks = {};
		this._fuzzyUpdateLoopCallbacks = {};
		this._resizeCallbacks = {};
		this._scrollCallbacks = {};
		this._waitForWebFontsCallbacks = {};
		this._webFontsLoaded = false;
		this._dynamicDependencies = {};
		this._viewportInfo = {
			scrollTop: (0, _shim.jQuery)(window).scrollTop(),
			scrollDirection: 'down',
			viewportWidth: window.innerWidth || (0, _shim.jQuery)(window).width(),
			viewportHeight: window.innerHeight || (0, _shim.jQuery)(window).height()
		};
		this._viewportInfo.breakpoint = this.getCurrentBreakpoint();

		initOrganisms(this);

		this._prepareClickedStates();
		this._setupGlobalEvents();
		this.startUpdateLoop();
	}

	(0, _createClass3.default)(App, [{
		key: '_prepareClickedStates',
		value: function _prepareClickedStates() {
			(0, _shim.jQuery)('body').on('click', 'a, button, .button, input[type=button], input[type=submit]', function () {
				var _this2 = this;

				(0, _shim.jQuery)(this).addClass('clicked');
				_shim.jQuery.schedule(200, function () {
					(0, _shim.jQuery)(_this2).removeClass('clicked').blur();
				});
			});
		}
	}, {
		key: '_setupGlobalEvents',
		value: function _setupGlobalEvents() {
			var _this3 = this;

			(0, _shim.jQuery)(window).on('scroll.app', _shim.lodash.throttle(function () {
				_shim.lodash.each(_this3._scrollCallbacks, function (callback) {
					callback();
				});
			}, 100));

			(0, _shim.jQuery)(window).on('resize.app', _shim.lodash.throttle(function () {
				_shim.lodash.each(_this3._resizeCallbacks, function (callback) {
					callback();
				});

				(0, _shim.jQuery)(window).triggerHandler('scroll.app');
			}, 100));

			_shim.jQuery.waitForWebfonts(['SpaceMono-BoldItalic', 'SpaceMono-Bold', 'SpaceMono-Italic', 'SpaceMono-Regular', 'Poppins-Regular', 'Poppins-Italic', 'Poppins-Medium', 'Poppins-MediumItalic', 'Poppins-Semibold', 'Poppins-SemiboldItalic', 'Poppins-Bold', 'Poppins-BoldItalic', 'Syne-Regular', 'Syne-Medium', 'Syne-Semibold', 'Syne-Bold', 'Source-Han-Sans-CN-Regular', 'Source-Han-Sans-CN-Medium', 'Source-Han-Sans-CN-Bold', 'Source-Han-Sans-JP-Regular', 'Source-Han-Sans-JP-Medium', 'Source-Han-Sans-JP-Bold', 'Source-Han-Sans-KR-Regular', 'Source-Han-Sans-KR-Medium', 'Source-Han-Sans-KR-Bold'], function () {
				_this3._webFontsLoaded = true;

				_shim.lodash.each(_this3._waitForWebFontsCallbacks, function (callback) {
					callback();
				});
			}, 'helvetica, sans-serif');
		}
	}, {
		key: 'startUpdateLoop',
		value: function startUpdateLoop() {
			var _this_ = this;

			var throttledUpdate = _shim.lodash.throttle(function () {
				_this_._updateViewportInfo();

				_shim.lodash.each(_this_._updateLoopCallbacks, function (callback) {
					callback(_this_._viewportInfo);
				});
			}, Math.round(1000 / TARGET_FPS));

			var throttledFuzzyUpdate = _shim.lodash.throttle(function () {
				_shim.lodash.each(_this_._fuzzyUpdateLoopCallbacks, function (callback) {
					callback(_this_._viewportInfo);
				});
			}, Math.round(1000 / FUZZY_TARGET_FPS));

			function step() {
				throttledUpdate();
				throttledFuzzyUpdate();
				_this_._updateLoop = requestAnimationFrame(step);
			}

			this._updateLoop = requestAnimationFrame(step);
		}
	}, {
		key: 'stopUpdateLoop',
		value: function stopUpdateLoop() {
			if (_shim.jQuery.isSet(this._updateLoop)) {
				cancelAnimationFrame(this._updateLoop);
				this._updateLoop = null;
			}
		}
	}, {
		key: 'registerUpdateLoopCallback',
		value: function registerUpdateLoopCallback(name, callback) {
			_shim.jQuery.assert(_shim.jQuery.isSet(name), 'app.registerUpdateLoopCallback | name is not defined');
			_shim.jQuery.assert(_shim.jQuery.isFunction(callback), 'app.registerUpdateLoopCallback | callback is not a function');

			name = '' + name;

			this._updateLoopCallbacks[name] = callback;

			return name;
		}
	}, {
		key: 'unregisterUpdateLoopCallback',
		value: function unregisterUpdateLoopCallback(name) {
			_shim.jQuery.assert(_shim.jQuery.isSet(name), 'app.registerUpdateLoopCallback | name is not defined');

			name = '' + name;

			if (_shim.jQuery.isSet(this._updateLoopCallbacks[name])) {
				delete this._updateLoopCallbacks[name];
			}

			return name;
		}
	}, {
		key: 'registerFuzzyUpdateLoopCallback',
		value: function registerFuzzyUpdateLoopCallback(name, callback) {
			_shim.jQuery.assert(_shim.jQuery.isSet(name), 'app.registerFuzzyUpdateLoopCallback | name is not defined');
			_shim.jQuery.assert(_shim.jQuery.isFunction(callback), 'app.registerFuzzyUpdateLoopCallback | callback is not a function');

			name = '' + name;

			this._fuzzyUpdateLoopCallbacks[name] = callback;

			return name;
		}
	}, {
		key: 'unregisterFuzzyUpdateLoopCallback',
		value: function unregisterFuzzyUpdateLoopCallback(name) {
			_shim.jQuery.assert(_shim.jQuery.isSet(name), 'app.unregisterFuzzyUpdateLoopCallback | name is not defined');

			name = '' + name;

			if (_shim.jQuery.isSet(this._fuzzyUpdateLoopCallbacks[name])) {
				delete this._fuzzyUpdateLoopCallbacks[name];
			}

			return name;
		}
	}, {
		key: 'registerResizeCallback',
		value: function registerResizeCallback(name, callback) {
			_shim.jQuery.assert(_shim.jQuery.isSet(name), 'app.registerResizeCallback | name is not defined');
			_shim.jQuery.assert(_shim.jQuery.isFunction(callback), 'app.registerResizeCallback | callback is not a function');

			this._resizeCallbacks['' + name] = callback;
		}
	}, {
		key: 'unregisterResizeCallback',
		value: function unregisterResizeCallback(name) {
			_shim.jQuery.assert(_shim.jQuery.isSet(name), 'app.unregisterResizeCallback | name is not defined');

			if (_shim.jQuery.isSet(this._resizeCallbacks['' + name])) {
				delete this._resizeCallbacks['' + name];
			}
		}
	}, {
		key: 'registerScrollCallback',
		value: function registerScrollCallback(name, callback) {
			_shim.jQuery.assert(_shim.jQuery.isSet(name), 'app.registerScrollCallback | name is not defined');
			_shim.jQuery.assert(_shim.jQuery.isFunction(callback), 'app.registerScrollCallback | callback is not a function');

			this._scrollCallbacks['' + name] = callback;
		}
	}, {
		key: 'unregisterScrollCallback',
		value: function unregisterScrollCallback(name) {
			_shim.jQuery.assert(_shim.jQuery.isSet(name), 'app.unregisterScrollCallback | name is not defined');

			if (_shim.jQuery.isSet(this._scrollCallbacks['' + name])) {
				delete this._scrollCallbacks['' + name];
			}
		}
	}, {
		key: 'registerWaitForWebFontsCallback',
		value: function registerWaitForWebFontsCallback(name, callback) {
			_shim.jQuery.assert(_shim.jQuery.isSet(name), 'app.registerWaitForWebFontsCallback | name is not defined');
			_shim.jQuery.assert(_shim.jQuery.isFunction(callback), 'app.registerWaitForWebFontsCallback | callback is not a function');

			if (!this._webFontsLoaded) {
				this._waitForWebFontsCallbacks['' + name] = callback;
			} else {
				_shim.lodash.defer(function () {
					callback();
				});
			}
		}
	}, {
		key: 'unregisterWaitForWebFontsCallback',
		value: function unregisterWaitForWebFontsCallback(name) {
			_shim.jQuery.assert(_shim.jQuery.isSet(name), 'app.unregisterWaitForWebFontsCallback | name is not defined');

			if (_shim.jQuery.isSet(this._waitForWebFontsCallbacks['' + name])) {
				delete this._waitForWebFontsCallbacks['' + name];
			}
		}
	}, {
		key: 'loadDynamicDependency',
		value: function loadDynamicDependency(name, url, expectedVal) {
			var async = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
			var defer = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

			_shim.jQuery.assert(_shim.jQuery.isSet(name), 'app.registerDynamicDependency | name is no defined');
			_shim.jQuery.assert(_shim.jQuery.isSet(url), 'app.registerDynamicDependency | url is no defined');

			if (this._dynamicDependencies['' + name]) {
				return this._dynamicDependencies['' + name];
			} else {
				var pollEndTime = Number(new Date()) + 5000,
				    pollInterval = 1000,
				    deferred = _shim.jQuery.Deferred(),
				    $script = document.createElement('script');
				$script.async = async;
				$script.defer = defer;

				$script.onerror = function () {
					deferred.reject('script could not be loaded');
				};

				this._dynamicDependencies['' + name] = deferred;

				if (!_shim.jQuery.isSet(expectedVal)) {
					$script.onload = function () {
						deferred.resolve();
					};
				} else {
					$script.onload = function () {
						var checkForExpectedValue = function checkForExpectedValue() {
							if (_shim.lodash.has(window, expectedVal)) {
								deferred.resolve();
							} else if (Number(new Date()) < pollEndTime) {
								setTimeout(function () {
									requestAnimationFrame(checkForExpectedValue);
								}, pollInterval);
							} else {
								throw new Error('expectedVal: ' + expectedVal + 'not found');
							}
						};

						requestAnimationFrame(checkForExpectedValue);
					};
				}

				document.body.appendChild($script);
				$script.src = url;

				return deferred;
			}
		}
	}, {
		key: '_updateViewportInfo',
		value: function _updateViewportInfo() {
			var currentVpWidth = window.innerWidth || (0, _shim.jQuery)(window).width(),
			    currentBreakpoint = this.getBreakpointBySize(currentVpWidth),
			    oldBreakpoint = this.getBreakpointBySize(this._viewportInfo.viewportWidth);

			this._viewportInfo.viewportWidth = currentVpWidth;
			this._viewportInfo.viewportHeight = window.innerHeight || (0, _shim.jQuery)(window).height();

			var newScrollTop = (0, _shim.jQuery)(window).scrollTop();
			if (newScrollTop > this._viewportInfo.scrollTop + 10) {
				this._viewportInfo.scrollDirection = 'down';
			} else if (newScrollTop < this._viewportInfo.scrollTop - 10) {
				this._viewportInfo.scrollDirection = 'up';
			}
			this._viewportInfo.scrollTop = newScrollTop;

			if (currentBreakpoint !== oldBreakpoint) {
				(0, _shim.jQuery)(window).triggerHandler('breakpointchange.app', [oldBreakpoint, currentBreakpoint]);
			}
			this._viewportInfo.breakpoint = currentBreakpoint;
		}
	}, {
		key: 'getBreakpointBySize',
		value: function getBreakpointBySize(size) {
			if (size < _defines.BREAKPOINT_TABLET) {
				return 'small';
			}

			if (size < _defines.BREAKPOINT_DESKTOP) {
				return 'medium';
			}

			return 'large';
		}
	}, {
		key: 'getCurrentBreakpoint',
		value: function getCurrentBreakpoint() {
			return this.getBreakpointBySize(this._viewportInfo.viewportWidth);
		}
	}, {
		key: 'getViewportInfo',
		value: function getViewportInfo() {
			return this._viewportInfo;
		}
	}]);
	return App;
}();

// init whole app only when document is ready, this call method prevents the need for any other document ready
// handlers and constitutes only a very minimal offset from the call in the body foot


(0, _shim.jQuery)(function () {
	var app = new App();
});

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(350);
var $Object = __webpack_require__(139).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(351);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(72), 'Object', { defineProperty: __webpack_require__(140).f });


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(138);
var core = __webpack_require__(139);
var ctx = __webpack_require__(352);
var hide = __webpack_require__(354);
var has = __webpack_require__(360);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(353);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 353 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(140);
var createDesc = __webpack_require__(359);
module.exports = __webpack_require__(72) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(100);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(72) && !__webpack_require__(141)(function () {
  return Object.defineProperty(__webpack_require__(357)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(100);
var document = __webpack_require__(138).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(100);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 359 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 360 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

exports.init = init;

var _shim = __webpack_require__(2);

var _defines = __webpack_require__(31);

var _scrollLock = __webpack_require__(362);

var _toggle = __webpack_require__(363);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SELECTOR = '.organism-header';

var Megamenu = function () {
	function Megamenu(menuWrapper, navContainer, subNavContainer, teaserContainer, navigationTree) {
		var _this = this;

		(0, _classCallCheck3.default)(this, Megamenu);

		this.menuWrapper = menuWrapper;
		this.navContainer = navContainer;
		this.subNavContainer = subNavContainer;
		this.teaserContainer = teaserContainer;
		this.navigationTree = navigationTree;
		this.isOpen = false;

		(0, _shim.jQuery)('main').on('click', function () {
			_this.closeMegamenu();
		});

		(0, _shim.jQuery)(window).on('scroll', function () {
			_this.closeMegamenu();
		});
	}

	(0, _createClass3.default)(Megamenu, [{
		key: 'fadeOut',
		value: function fadeOut(cb) {
			this.menuWrapper.animate({ opacity: 0 }, { done: cb });
		}
	}, {
		key: 'fadeIn',
		value: function fadeIn(cb) {
			this.menuWrapper.animate({ opacity: 1 }, { done: cb });
		}
	}, {
		key: 'setSubNavigation',
		value: function setSubNavigation(subItems) {
			var _this2 = this;

			this.subNavContainer.empty();

			if (subItems && subItems.length) {
				this.menuWrapper.addClass('wide');

				subItems.forEach(function (item, idx) {
					item.link.removeClass('inactive');

					_this2.subNavContainer.append(item.link);

					if (idx === 0) {
						item.link.addClass('current');
					} else {
						item.link.removeClass('current');
					}

					item.link.on('click', function () {
						if (item.children && item.children.length) {
							return _this2.navigate(item.parent, item);
						}

						if (item.teaser) {
							_this2.showTeaser(item.teaser);
						}

						item.link.siblings().removeClass('current');
						item.link.addClass('current');
					});
				});

				return this.subNavContainer.fadeIn();
			}

			this.subNavContainer.fadeOut(0);
			this.menuWrapper.removeClass('wide');
		}
	}, {
		key: 'showTeaser',
		value: function showTeaser(teaser) {
			var _this3 = this;

			return this.teaserContainer.fadeOut(300, function () {
				_this3.teaserContainer.empty();
				_this3.teaserContainer.append(teaser.clone().contents());
				_this3.teaserContainer.fadeIn(300);
			});
		}
	}, {
		key: 'closeMegamenu',
		value: function closeMegamenu() {
			var _this4 = this;

			if (this.isOpen) {
				this.isOpen = false;
				this.teaserContainer.fadeOut(300, function () {
					_this4.teaserContainer.empty();
				});
				this.subNavContainer.fadeOut(300, function () {
					_this4.subNavContainer.empty();
				});

				this.fadeOut(function () {
					(0, _shim.jQuery)('.megamenu').slideUp(300);

					_this4.menuWrapper.trigger('megamenu.close');
				});
			}
		}
	}, {
		key: 'openMegamenu',
		value: function openMegamenu(index) {
			var _this5 = this;

			var menuRoot = this.navigationTree[index];

			if (menuRoot.children.length) {
				this.navigate(menuRoot);
				this.isOpen = true;

				(0, _shim.jQuery)('.megamenu').slideDown(300, function () {
					_this5.fadeIn();
				});
			} else {
				this.closeMegamenu();
			}
		}
	}, {
		key: 'initMegamenuNavigation',
		value: function initMegamenuNavigation(navItems) {
			var _this6 = this;

			this.menuWrapper.on('megamenu.close', function () {
				navItems.removeClass('current');

				if (navItems.hasClass('active')) {
					navItems.filter('.active').removeClass('inactive');
				} else {
					navItems.removeClass('inactive');
				}
			});

			navItems.each(function (index, el) {
				var $this = (0, _shim.jQuery)(el);

				if (navItems.hasClass('active') && !$this.hasClass('active')) {
					$this.addClass('inactive');
				}

				if (!$this.attr('href')) {
					$this.on('click', function () {
						if (!$this.hasClass('current')) {
							$this.addClass('current');
							$this.siblings().removeClass('current');
							$this.siblings().addClass('inactive');

							return _this6.openMegamenu(index);
						} else {
							$this.siblings('.active').removeClass('inactive');

							return _this6.closeMegamenu();
						}
					});
				}
			});
		}
	}, {
		key: 'navigate',
		value: function navigate(root, currentNode) {
			var _this7 = this;

			if (!root) return;
			this.menuWrapper.removeClass('wide');
			this.navContainer.empty();

			var inactivate = function inactivate(isInactive) {
				root.children.forEach(function (item) {
					return isInactive ? item.link.addClass('inactive') : item.link.removeClass('inactive');
				});
			};

			root.children.forEach(function (item) {
				var el = item.link;

				el.removeClass('current');
				_this7.navContainer.append(el);
				item.link.removeClass('inactive');

				if (currentNode) {
					item.link.addClass('inactive');

					if (currentNode === item) {
						item.link.addClass('current');
						item.link.removeClass('inactive');
					}
				} else {
					if (item.link.hasClass('summary')) {
						item.link.addClass('current');
					}
				}

				el.one('click', function () {
					if (item === currentNode || item.link.hasClass('summary')) {
						var prevParent = item.parent.parent;

						if (prevParent && prevParent !== root) {
							return _this7.navigate(prevParent, item.parent);
						}

						return _this7.navigate(root);
					}

					return _this7.navigate(root, item);
				});
			});

			this.setSubNavigation(currentNode && currentNode.children);

			var teaser = currentNode && currentNode.teaser || root && root.children && root.children[0] && root.children[0].teaser;

			if (teaser) {
				this.showTeaser(teaser);
			}
		}
	}]);
	return Megamenu;
}();

var OrganismHeader = function () {
	function OrganismHeader(app, $element) {
		(0, _classCallCheck3.default)(this, OrganismHeader);

		if (!_shim.jQuery.isSet($element.dataDuo('primed'))) {
			$element.dataDuo('primed', true);

			this._app = app;
			this._id = _shim.jQuery.randomUuid(true);
			this._$element = $element;

			this._$pageHeader = this._$element.find('.page-header');
			this._$mobileTabletVersion = this._$element.find('.mobile-tablet-version').first();
			this._$burgerNavigationHolder = this._$element.find('.burger-menu').first();
			this._$burgerNavigationMenu = this._$burgerNavigationHolder.find('.burger-menu-content > .menu').first();
			this._$mobileTabletNav = this._$mobileTabletVersion.find('.menu-holder').first();
			this._$desktopVersion = this._$element.find('.desktop-version').first();
			this._$desktopNavigationMenuHolder = this._$element.find('.megamenu-wrapper').first();
			this._$desktopNavigationMenu = this._$element.find('.menu-holder > .megamenu').first();
			this._$metaNavigation = this._$desktopVersion.find('.meta-navigation-wrapper').first();
			this._$mainNavigation = this._$desktopVersion.find('.main-navigation-wrapper').first();
			this._$desktopLevel1HighlightFlyouts = this._$desktopVersion.find('.level-1-highlights .level-1-flyout');

			this._$burgerNavigationItems = this._$burgerNavigationHolder.find('.navigation-items');
			this._$mobileTabletMenuTree = this.buildNavigationTree(this._$burgerNavigationItems.children('.nav-item').clone().toArray());

			this._$megaMenuNavigationItems = this._$desktopNavigationMenuHolder.find('.navigation-items');
			this._$desktopMenuTree = this.buildNavigationTree(this._$megaMenuNavigationItems.children('.nav-item').clone().toArray());

			this.mobileTabletBurgermenu = new Megamenu((0, _shim.jQuery)('.megamenu .menu-holder'), (0, _shim.jQuery)('.megamenu .menu-holder .menu'), (0, _shim.jQuery)('.megamenu .menu-holder .submenu'), (0, _shim.jQuery)('.megamenu .megamenu-teaser'), this._$mobileTabletMenuTree);

			this.desktopMegamenu = new Megamenu((0, _shim.jQuery)('.megamenu .menu-holder'), (0, _shim.jQuery)('.megamenu .menu-holder .menu'), (0, _shim.jQuery)('.megamenu .menu-holder .submenu'), (0, _shim.jQuery)('.megamenu .megamenu-teaser'), this._$desktopMenuTree);

			this._prime();
		}

		return $element;
	}

	(0, _createClass3.default)(OrganismHeader, [{
		key: '_prime',
		value: function _prime() {
			var _this8 = this;

			this._$mobileTabletNav.each(function (_, el) {
				var $nav = (0, _shim.jQuery)(el),
				    $toggle = $nav.find('.burger-button').first();

				$toggle.on('click', function (e) {
					e.preventDefault();

					if (!$nav.hasClass('open')) {
						$nav.addClass('open');
						_this8._$burgerNavigationHolder.addClass('open');

						if (_defines.IS_IOS_SAFARI) {
							(0, _scrollLock.lockScroll)();
						}
					} else {
						$nav.removeClass('open');
						_this8._$burgerNavigationHolder.removeClass('open');

						if (_defines.IS_IOS_SAFARI) {
							(0, _scrollLock.unlockScroll)();
						}
					}

					(0, _shim.jQuery)('body').toggleClass('overlayed');
				});

				(0, _shim.jQuery)(window).on('breakpointchange.app', function (e, oldBreakpoint, newBreakpoint) {
					if (newBreakpoint === 'large' && $nav.hasClass('open')) {
						$toggle.triggerHandler('click');
					}
				});
			});

			(0, _shim.jQuery)(window).on('scroll', function () {
				_this8.makeSticky();
			});

			this._$pageHeader.each(function (_, header) {
				_this8.desktopMegamenu.initMegamenuNavigation((0, _shim.jQuery)(header).find('.main-nav-link'));
			});

			(0, _toggle.prepareToggles)(this._$element);

			this.initMobileNavigation();
		}
	}, {
		key: 'makeSticky',
		value: function makeSticky() {
			var self = this;
			var $header = this._$element;
			var $pageHeader = $header.find('.page-header');
			var $headerHeight = $pageHeader.outerHeight(true);
			var $scrollTop = (0, _shim.jQuery)(window).scrollTop();

			if ($scrollTop > $headerHeight) {
				$header.removeClass('collapsed');
				if (!$header.hasClass('sticky')) {
					$header.addClass('sticky');
				}
				return;
			}
			if ($header.hasClass('sticky')) {
				$header.addClass('collapsed');
			}
			return $header.removeClass('sticky');
		}
	}, {
		key: 'buildNavigationTree',
		value: function buildNavigationTree(items, parent) {
			var _this9 = this;

			return items.map(function (item) {
				var $item = (0, _shim.jQuery)(item);
				var subItems = $item.children('.sub-items');
				var link = $item.children('.nav-link');
				var result = { parent: parent, link: link, item: $item, teaser: $item.children('.teaser-content').first() };

				if (subItems) {
					result.children = _this9.buildNavigationTree(subItems.children('.nav-item').toArray(), result);
				}

				return result;
			});
		}
	}, {
		key: 'mobileNavigation',
		value: function mobileNavigation(container, root, defaultRoot, event) {
			var _this10 = this;

			return function () {
				var directionValue = '',
				    newStartingPos = '';

				if (event !== undefined && (0, _shim.jQuery)(event.currentTarget).hasClass('prev')) {
					directionValue = '100%';
					newStartingPos = '-100%';
				} else {
					directionValue = '-100%';
					newStartingPos = '100%';
				}

				if (event === undefined || !(0, _shim.jQuery)(event.currentTarget).attr('href')) {
					container.animate({
						'left': directionValue,
						'height': 'toggle'
					}, 500, function () {
						container.css('left', newStartingPos);

						container.empty();
						container.removeClass('sub');

						if (root.item) {
							container.addClass('sub');
							var prev = root.item.clone();
							var prevLink = prev.children('.nav-link');

							prevLink.addClass('prev');
							prevLink.on('click', function (e) {
								return _this10.mobileNavigation(container, root.parent || defaultRoot, defaultRoot, e);
							});

							container.append(prev);
						}

						root.children.forEach(function (item) {
							container.append(item.item);
							item.link.on('click', function (e) {
								return _this10.mobileNavigation(container, item, defaultRoot, e);
							});
						});

						if (root.item) {
							if (container.children('.nav-item').first().children('.nav-link').hasClass('active')) {
								container.children('.nav-item').first().children('.nav-link').removeClass('active');
								container.children('.nav-item').first().next().children('.nav-link.summary').addClass('active');
							}
						}

						container.animate({
							'left': '0',
							'height': 'toggle'
						}, 500);
					});
				}
			}();
		}
	}, {
		key: 'initMobileNavigation',
		value: function initMobileNavigation() {
			var root = { children: this._$mobileTabletMenuTree };

			this.mobileNavigation(this._$burgerNavigationMenu, root, root);
		}
	}]);
	return OrganismHeader;
}();

function init(app) {
	var $elements = (0, _shim.jQuery)();

	(0, _shim.jQuery)(SELECTOR).each(function () {
		var $this = (0, _shim.jQuery)(this);

		$elements = $elements.add(new OrganismHeader(app, $this));
	});

	return $elements;
}

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.lockScroll = lockScroll;
exports.unlockScroll = unlockScroll;

var _shim = __webpack_require__(2);

/*
	Needs this css to work.
	Should only be used in really problematic cases such as form inputs in fixed layers
	in iOS Safari < 11.3.

	body.scroll-locked {
		overflow: hidden;

		position: fixed;
		left: 0;

		width: 100%;
		height: 100%;
	}
*/

function lockScroll() {
	(0, _shim.jQuery)('body').data('scroll-lock-scroll-top', (0, _shim.jQuery)(window).scrollTop()).addClass('scroll-locked').css('top', (0, _shim.jQuery)(window).scrollTop());
}

function unlockScroll() {
	var $body = (0, _shim.jQuery)('body');

	$body.removeClass('scroll-locked').css('top', '');

	if ($body.data('scroll-lock-scroll-top')) {
		window.scrollTo(0, parseInt($body.data('scroll-lock-scroll-top'), 10));
		$body.removeData('scroll-lock-scroll-top');
	}
}

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.prepareToggles = prepareToggles;

var _shim = __webpack_require__(2);

var TOGGLE_DATA_MARKER = 'data-toggle',
    TOGGLE_DATA_MARKER_CLOSE = 'data-close';

/*
 * todo: This is the rewrite of Stephan Bruny's global applyToggle() function, which was globally
 * called in app.js (which is a terrible way to do such things). The only place I found this was used
 * was in the global page header, so I moved the code to this snippet and imported and used it explicitly there.
 *
 * This is still not a beautiful solution, but should work for the time being
 */
function prepareToggles($target) {
	var $targets = $target.find('[' + TOGGLE_DATA_MARKER + ']');

	$targets.on('click', function (e) {
		e.preventDefault();

		var $sameTargetToggles = $targets.filter('[' + TOGGLE_DATA_MARKER + '="' + (0, _shim.jQuery)(this).attr(TOGGLE_DATA_MARKER) + '"]'),
		    $toggleTarget = (0, _shim.jQuery)((0, _shim.jQuery)(this).attr(TOGGLE_DATA_MARKER)),
		    $closingChildren = $toggleTarget.find('[' + TOGGLE_DATA_MARKER_CLOSE + ']');

		if (!(0, _shim.jQuery)(this).hasClass('active')) {
			(0, _shim.jQuery)(this).add($sameTargetToggles).addClass('active');
			$toggleTarget.removeClass('hidden');

			$closingChildren.each(function () {
				var _this = this;

				(0, _shim.jQuery)(this).off('click.toggle').one('click.toggle', function (e) {
					e.preventDefault();

					(0, _shim.jQuery)(_this).add($sameTargetToggles).removeClass('active');
					$toggleTarget.addClass('hidden');
				});
			});
		} else {
			(0, _shim.jQuery)(this).add($sameTargetToggles).removeClass('active');
			$toggleTarget.addClass('hidden');
		}
	});
}

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

exports.init = init;

var _shim = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SELECTOR = '.organism-footer';

var OrganismFooter = function () {
	function OrganismFooter(app, $element) {
		(0, _classCallCheck3.default)(this, OrganismFooter);

		if (!_shim.jQuery.isSet($element.dataDuo('primed'))) {
			$element.dataDuo('primed', true);

			this._app = app;
			this._id = _shim.jQuery.randomUuid(true);
			this._$element = $element;

			this._$footerMetaHolder = this._$element.find('.footer-meta-holder').first();
			this._$languageButtons = this._$footerMetaHolder.find('.language-menu-button');
			this._$footerLanguagesWrapper = this._$footerMetaHolder.find('.footer-languages-wrapper').first();

			this._prime();
		}

		return $element;
	}

	(0, _createClass3.default)(OrganismFooter, [{
		key: '_prime',
		value: function _prime() {
			var _this_ = this;

			this._$languageButtons.each(function () {
				var $currentButton = (0, _shim.jQuery)(this);
				var timeout = null;

				$currentButton.on('click', function (e) {
					e.preventDefault();

					if (!$currentButton.hasClass('active')) {
						$currentButton.addClass('active');

						_this_._$footerLanguagesWrapper.removeClass('hidden');

						var offsetHeaderTop = (0, _shim.jQuery)('header.sticky-header').height();

						(0, _shim.jQuery)("html, body").delay(250).animate({ scrollTop: (0, _shim.jQuery)('.footer-languages-wrapper').offset().top - offsetHeaderTop }, 500);
					} else {
						clearTimeout(timeout);
						$currentButton.removeClass('active');
						_this_._$footerLanguagesWrapper.addClass('hidden');
					}
				});

				(0, _shim.jQuery)(window).on('breakpointchange.app', function (e, oldBreakpoint, newBreakpoint) {
					if ($currentButton.hasClass('active')) {
						$currentButton.triggerHandler('click');
					}
				});
			});
		}
	}]);
	return OrganismFooter;
}();

function init(app) {
	var $elements = (0, _shim.jQuery)();

	(0, _shim.jQuery)(SELECTOR).each(function () {
		var $this = (0, _shim.jQuery)(this);

		$elements = $elements.add(new OrganismFooter(app, $this));
	});

	return $elements;
}

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

exports.init = init;

var _shim = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NAME = 'organism-contact-panel',
    SELECTOR = '.' + NAME;

var OrganismContactPanel = function () {
	function OrganismContactPanel(app, $element) {
		(0, _classCallCheck3.default)(this, OrganismContactPanel);

		if (!_shim.jQuery.isSet($element.dataDuo('primed'))) {
			$element.dataDuo('primed', true);

			this._app = app;
			this._id = _shim.jQuery.randomUuid(true);
			this._$element = $element;
			this._$content = this._$element.find('.contact-panel-content').first();
			this._$closedContent = this._$element.find('.contact-panel-closed').first();
			this._$openButton = this._$closedContent.find('.closed-text').first();
			this._$closeButton = this._$content.find('.close-button').first();

			this._prime();
		}

		return $element;
	}

	(0, _createClass3.default)(OrganismContactPanel, [{
		key: '_prime',
		value: function _prime() {
			var _this = this;

			var closedContentWidth = 0,
			    closedContentHeight = 0;

			closedContentWidth = this._$closedContent.outerWidth();
			this._$openButton.css('width', closedContentWidth);
			this._$closedContent.css('height', closedContentWidth);

			this._$closeButton.on('click', function () {
				closedContentWidth = _this._$closedContent.outerWidth();
				_this._$openButton.css('width', closedContentWidth);

				_this._$closedContent.finish();

				_this._$content.fadeOut(250, function () {
					_this._$closedContent.animate({ width: 'toggle' });
				});
			});

			this._$openButton.on('click', function () {
				closedContentWidth = _this._$closedContent.outerWidth();
				closedContentHeight = _this._$closedContent.outerHeight();
				_this._$openButton.css('width', closedContentWidth);
				_this._$closedContent.css('height', closedContentWidth);

				_this._$content.finish();

				_this._$closedContent.animate({ width: 'toggle' }, 250, 'linear', function () {
					_this._$content.fadeIn();
				});
			});
		}
	}]);
	return OrganismContactPanel;
}();

function init(app) {
	var $elements = (0, _shim.jQuery)();

	(0, _shim.jQuery)(SELECTOR).each(function () {
		var $this = (0, _shim.jQuery)(this);

		$elements = $elements.add(new OrganismContactPanel(app, $this));
	});

	return $elements;
}

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

exports.init = init;

var _shim = __webpack_require__(2);

var _context = __webpack_require__(37);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SELECTOR = '.organism-sticky-page-up';

var OrganismStickyPageUp = function () {
	function OrganismStickyPageUp(app, $element) {
		(0, _classCallCheck3.default)(this, OrganismStickyPageUp);

		if (!_shim.jQuery.isSet($element.dataDuo('primed'))) {
			$element.dataDuo('primed', true);

			this._app = app;
			this._id = _shim.jQuery.randomUuid(true);
			this._$element = $element;

			this._$button = this._$element.find('.page-up-button').first();

			this._$footerNav = (0, _shim.jQuery)('.organism-footer').first();

			this._originalBottomOffset = parseInt(this._$element.css('bottom'), 10) || 0;

			this._prime();
		}
	}

	(0, _createClass3.default)(OrganismStickyPageUp, [{
		key: '_prime',
		value: function _prime() {
			var _this = this;

			this._$element.css('bottom', this._originalBottomOffset);

			this._$button.on('click', function (e) {
				e.preventDefault();

				(0, _shim.jQuery)('body').scrollTo(function () {
					_this._$button.blur();
				}, 750, Math.round(_this._app.getViewportInfo().viewportHeight / 2), true, true);
			});

			if (!_context.Context.get('runningInPatternLabList') && !_context.Context.get('runningInPatternLabDetails')) {
				this._app.registerFuzzyUpdateLoopCallback('sticky-page-up-management', function (viewportInfo) {
					if (viewportInfo.scrollDirection === 'down' && viewportInfo.scrollTop >= viewportInfo.viewportHeight) {
						if (!_this._$element.hasClass('active')) {
							_this._$element.addClass('active');
						}
						if (_this._$element.hasClass('scroll-up')) {
							_this._$element.removeClass('scroll-up');
						}
						if (viewportInfo.scrollTop + viewportInfo.viewportHeight > _this._$footerNav.offset().top) {
							if (!_this._$element.hasClass('not-sticky')) {
								_this._$element.addClass('not-sticky');
							}
						} else if (_this._$element.hasClass('not-sticky')) {
							_this._$element.removeClass('not-sticky');
						}
					} else if (viewportInfo.scrollDirection === 'up') {
						if (!_this._$element.hasClass('scroll-up')) {
							_this._$element.addClass('scroll-up');
						}
						if (viewportInfo.scrollTop < viewportInfo.viewportHeight) {
							if (_this._$element.hasClass('active')) {
								_this._$element.removeClass('active');
							}
						}
						if (viewportInfo.scrollTop + viewportInfo.viewportHeight < _this._$footerNav.offset().top) {
							if (_this._$element.hasClass('not-sticky')) {
								_this._$element.removeClass('not-sticky');
							}
						}
					}
				});

				//###( EVENTS )###

				this._$element.on('hide-on-page.app', function () {
					_this._$element.addClass('hidden');
				});

				this._$element.on('show-on-page.app', function () {
					_this._$element.removeClass('hidden');
				});
			}
		}
	}]);
	return OrganismStickyPageUp;
}();

function init(app) {
	var $elements = (0, _shim.jQuery)();

	(0, _shim.jQuery)(SELECTOR).each(function () {
		var $this = (0, _shim.jQuery)(this);
		new OrganismStickyPageUp(app, $this);
		$elements = $elements.add($this);
	});

	return $elements;
}

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

exports.init = init;

var _shim = __webpack_require__(2);

var _context = __webpack_require__(37);

var _dom = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SELECTOR = '.organism-privacy-layer';

var OrganismPrivacyLayer = function () {
	function OrganismPrivacyLayer(app, $element) {
		(0, _classCallCheck3.default)(this, OrganismPrivacyLayer);

		if (!_shim.jQuery.isSet($element.dataDuo('primed'))) {
			$element.dataDuo('primed', true);

			this._app = app;
			this._id = _shim.jQuery.randomUuid(true);
			this._$element = $element;

			this._$acknowledgeButton = this._$element.find('.acknowledge-button');

			this._privacyAlreadyAccepted = window.localStorage.getItem('witzenmann-privacy-accepted') === 'true';

			this._prime();
			this._initPatternLabDemoBehaviour();
		}
	}

	(0, _createClass3.default)(OrganismPrivacyLayer, [{
		key: '_prime',
		value: function _prime() {
			var _this = this;

			if (!this._privacyAlreadyAccepted) {
				this._$element.addClass('needs-acknowledgement');

				(0, _dom.waitForRepaint)(function () {
					_this._$element.addClass('waiting-for-acknowledgement');
				});
			}

			this._$acknowledgeButton.on('click', function (e) {
				e.preventDefault();

				window.localStorage.setItem('witzenmann-privacy-accepted', 'true');

				_this._$element.cssTransition({ addClass: 'privacy-accepted', removeClass: 'wait-for-acknowledgement' }, function () {
					_this._$element.removeClass('needs-acknowledgement');
				});
			});
		}
	}, {
		key: '_initPatternLabDemoBehaviour',
		value: function _initPatternLabDemoBehaviour() {
			var _this2 = this;

			if ((_context.Context.get('runningInPatternLabList') || _context.Context.get('runningInPatternLabDetails')) && this._$element.parent().closest('[class^="organism-"]').length === 0) {
				this._privacyAlreadyAccepted = false;

				this._$element.addClass('needs-acknowledgement');
				(0, _dom.waitForRepaint)(function () {
					_this2._$element.addClass('waiting-for-acknowledgement');
				});

				this._$acknowledgeButton.off('click').on('click', function (e) {
					e.preventDefault();

					_this2._$element.cssTransition({ addClass: 'privacy-accepted', removeClass: 'wait-for-acknowledgement' }, function () {
						_this2._$element.removeClass('needs-acknowledgement');
					});
				});
			}
		}
	}]);
	return OrganismPrivacyLayer;
}();

function init(app) {
	var $elements = (0, _shim.jQuery)();

	(0, _shim.jQuery)(SELECTOR).each(function () {
		var $this = (0, _shim.jQuery)(this);
		new OrganismPrivacyLayer(app, $this);
		$elements = $elements.add($this);
	});

	return $elements;
}

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

exports.init = init;

var _shim = __webpack_require__(2);

var _defines = __webpack_require__(31);

var _context = __webpack_require__(37);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SELECTOR = '.organism-message-overlay';

var OrganismMessageOverlay = function () {
	function OrganismMessageOverlay(app, $element) {
		(0, _classCallCheck3.default)(this, OrganismMessageOverlay);

		if (!_shim.jQuery.isSet($element.dataDuo('primed'))) {
			$element.dataDuo('primed', true);

			this._app = app;
			this._id = _shim.jQuery.randomUuid(true);
			this._$element = $element;

			this._$acknowledgeButton = this._$element.find('.acknowledge-button');
			this._overlayId = this._$element.data('overlay-id');
			this._$overlayTrigger = (0, _shim.jQuery)('body').find('.overlay-trigger[data-overlay-id="' + this._overlayId + '"], .cta-link[data-overlay-id="' + this._overlayId + '"]');

			this._prime();
			this._initPatternLabDemoBehaviour();
		}
	}

	(0, _createClass3.default)(OrganismMessageOverlay, [{
		key: '_prime',
		value: function _prime() {
			var _this = this;

			this._$element.on('click', function (e) {
				e.preventDefault();

				if (!(0, _shim.jQuery)(event.target).closest('.background').length) {
					_this._$element.removeClass('open');
				}
			});

			this._$acknowledgeButton.on('click', function (e) {
				e.preventDefault();

				_this._$element.removeClass('open');
				if (_this._$overlayTrigger.attr('href')) {
					window.location.href = _this._$overlayTrigger.attr('href');
				}
			});

			if (this._$overlayTrigger && this._$overlayTrigger.length && this._$overlayTrigger.data('overlay-id')) {
				this._$overlayTrigger.on('click', function (e) {
					e.preventDefault();
					_this._$element.addClass('open');
				});
			}
		}
	}, {
		key: '_initPatternLabDemoBehaviour',
		value: function _initPatternLabDemoBehaviour() {
			var _this2 = this;

			if ((_context.Context.get('runningInPatternLabDetails') || _context.Context.get('runningInPatternLabList')) && this._$element.parent().closest('[class^="organism-"]').length === 0) {
				var $trigger = (0, _shim.jQuery)('<button class="atom-primary-button pl-test-button">open overlay</button>');

				$trigger.on('click', function (e) {
					e.preventDefault();

					_this2._$element.addClass('open');
				});

				this._$element.after($trigger);
			}

			if (_context.Context.get('runningInPatternLabList') && _defines.IS_IOS_SAFARI) {
				var $unavailableMessage = (0, _shim.jQuery)('<p class="pl-message">' + 'On iOS, the lightbox may be too high due to a pattern-lab-specific iFrame problem, ' + 'have a look at the pattern in the pattern detail view or try double tapping the lightbox ' + 'title to apply filters even if the apply button may be unreachable.' + '</p>');

				this._$element.after($unavailableMessage);
			}
		}
	}]);
	return OrganismMessageOverlay;
}();

function init(app) {
	var $elements = (0, _shim.jQuery)();

	(0, _shim.jQuery)(SELECTOR).each(function () {
		var $this = (0, _shim.jQuery)(this);
		new OrganismMessageOverlay(app, $this);
		$elements = $elements.add($this);
	});

	return $elements;
}

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

exports.init = init;

var _shim = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SELECTOR = ['.atom-select', 'select'];

var AtomSelect = function () {
	function AtomSelect(app, $element) {
		(0, _classCallCheck3.default)(this, AtomSelect);

		if (!_shim.jQuery.isSet($element.dataDuo('primed'))) {
			$element.dataDuo('primed', true);

			this._app = app;
			this._id = _shim.jQuery.randomUuid(true);
			this._$element = $element;
			this._$selectric = (0, _shim.jQuery)();

			this._prime();
		}

		return $element;
	}

	(0, _createClass3.default)(AtomSelect, [{
		key: '_prime',
		value: function _prime() {
			var _this = this;

			this._$element.selectric({
				nativeOnMobile: true,
				arrowButtonMarkup: '<span class="button"></span>',
				labelBuilder: function labelBuilder(currItem) {
					if (currItem.index === 0 && !currItem.value && currItem.selected) {
						return '<span class="default">' + currItem.text + '</span>';
					}
					return currItem.text;
				}
			});
			this._$selectric = this._$element.closest('.selectric-wrapper');

			this._$selectric.on('click', function (e) {
				_shim.lodash.defer(function () {
					if (_this._$selectric.hasClass('selectric-open')) {
						_this._$element.selectric('close');
					}
				});
			});

			// this._$element.on('selectric-change', (event, element, selectric) => {
			// 	$.log(event, element, selectric);
			// });

			if (this._$element.hasClass('error')) {
				this._$element.closest('.atom-inputlabel').addClass('error');
			}

			if (this._$element.is(':disabled')) {
				this._$element.closest('.atom-inputlabel').addClass('disabled');
			}
		}
	}]);
	return AtomSelect;
}();

function init(app) {
	var $elements = (0, _shim.jQuery)();

	(0, _shim.jQuery)(SELECTOR).each(function () {
		var $this = (0, _shim.jQuery)(this);

		$elements = $elements.add(new AtomSelect(app, $this));
	});

	return $elements;
}

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

exports.init = init;

var _shim = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SELECTOR = '.atom-checkbox';

var AtomCheckbox = function () {
	function AtomCheckbox(app, $element) {
		(0, _classCallCheck3.default)(this, AtomCheckbox);

		if (!_shim.jQuery.isSet($element.dataDuo('primed'))) {
			$element.dataDuo('primed', true);

			this._app = app;
			this._id = _shim.jQuery.randomUuid(true);
			this._$element = $element;

			this._prime();
		}

		return $element;
	}

	(0, _createClass3.default)(AtomCheckbox, [{
		key: '_prime',
		value: function _prime() {
			this._$element.makeStylable('stylable-checkbox atom-inputlabel');

			if (this._$element.hasClass('atom-checkbox')) {
				this._$element.removeClass('atom-checkbox').parent('.stylable-checkbox').addClass('atom-checkbox').end();
			}

			if (this._$element.hasClass('error')) {
				this._$element.removeClass('error').parent('.stylable-checkbox').addClass('error').end();
			}

			if (this._$element.is(':disabled')) {
				this._$element.parent('.stylable-checkbox').addClass('disabled').end();
			}
		}
	}]);
	return AtomCheckbox;
}();

function init(app) {
	var $elements = (0, _shim.jQuery)();

	(0, _shim.jQuery)(SELECTOR).each(function () {
		var $this = (0, _shim.jQuery)(this);

		$elements = $elements.add(new AtomCheckbox(app, $this));
	});

	return $elements;
}

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

exports.init = init;

var _shim = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SELECTOR = '.atom-radiobutton';

var AtomRadiobutton = function () {
	function AtomRadiobutton(app, $element) {
		(0, _classCallCheck3.default)(this, AtomRadiobutton);

		if (!_shim.jQuery.isSet($element.dataDuo('primed'))) {
			$element.dataDuo('primed', true);

			this._app = app;
			this._id = _shim.jQuery.randomUuid(true);
			this._$element = $element;

			this._prime();
		}

		return $element;
	}

	(0, _createClass3.default)(AtomRadiobutton, [{
		key: '_prime',
		value: function _prime() {
			this._$element.makeStylable('stylable-radiobutton atom-inputlabel');

			if (this._$element.hasClass('atom-radiobutton')) {
				this._$element.removeClass('atom-radiobutton').parent('.stylable-radiobutton').addClass('atom-radiobutton').end();
			}

			if (this._$element.hasClass('error')) {
				this._$element.removeClass('error').parent('.stylable-radiobutton').addClass('error').end();
			}

			if (this._$element.is(':disabled')) {
				this._$element.parent('.stylable-radiobutton').addClass('disabled').end();
			}
		}
	}]);
	return AtomRadiobutton;
}();

function init(app) {
	var $elements = (0, _shim.jQuery)();

	(0, _shim.jQuery)(SELECTOR).each(function () {
		var $this = (0, _shim.jQuery)(this);

		$elements = $elements.add(new AtomRadiobutton(app, $this));
	});

	return $elements;
}

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

exports.init = init;

var _shim = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SELECTOR = '.atom-textinput';

var AtomTextinput = function () {
	function AtomTextinput(app, $element) {
		(0, _classCallCheck3.default)(this, AtomTextinput);

		if (!_shim.jQuery.isSet($element.dataDuo('primed'))) {
			$element.dataDuo('primed', true);

			this._app = app;
			this._id = _shim.jQuery.randomUuid(true);
			this._$element = $element;

			this._prime();
		}

		return $element;
	}

	(0, _createClass3.default)(AtomTextinput, [{
		key: '_prime',
		value: function _prime() {
			if (this._$element.hasClass('error')) {
				this._$element.parent('.atom-inputlabel').addClass('error').end();
			}

			if (this._$element.is(':disabled')) {
				this._$element.parent('.atom-inputlabel').addClass('disabled').end();
			}
		}
	}]);
	return AtomTextinput;
}();

function init(app) {
	var $elements = (0, _shim.jQuery)();

	(0, _shim.jQuery)(SELECTOR).each(function () {
		var $this = (0, _shim.jQuery)(this);

		$elements = $elements.add(new AtomTextinput(app, $this));
	});

	return $elements;
}

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

exports.init = init;

var _shim = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SELECTOR = '.atom-textarea';

var AtomTextarea = function () {
	function AtomTextarea(app, $element) {
		(0, _classCallCheck3.default)(this, AtomTextarea);

		if (!_shim.jQuery.isSet($element.dataDuo('primed'))) {
			$element.dataDuo('primed', true);

			this._app = app;
			this._id = _shim.jQuery.randomUuid(true);
			this._$element = $element;

			this._prime();
		}

		return $element;
	}

	(0, _createClass3.default)(AtomTextarea, [{
		key: '_prime',
		value: function _prime() {
			if (this._$element.hasClass('error')) {
				this._$element.parent('.atom-inputlabel').addClass('error').end();
			}

			if (this._$element.is(':disabled')) {
				this._$element.parent('.atom-inputlabel').addClass('disabled').end();
			}
		}
	}]);
	return AtomTextarea;
}();

function init(app) {
	var $elements = (0, _shim.jQuery)();

	(0, _shim.jQuery)(SELECTOR).each(function () {
		var $this = (0, _shim.jQuery)(this);

		$elements = $elements.add(new AtomTextarea(app, $this));
	});

	return $elements;
}

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

exports.init = init;

var _shim = __webpack_require__(2);

var _dom = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NAME = 'molecule-in-page-navigation',
    SELECTOR = '.' + NAME;

var MoleculeInPageNavigation = function () {
	function MoleculeInPageNavigation(app, $element) {
		(0, _classCallCheck3.default)(this, MoleculeInPageNavigation);

		if (!_shim.jQuery.isSet($element.dataDuo('primed'))) {
			$element.dataDuo('primed', true);

			this._app = app;
			this._id = _shim.jQuery.randomUuid(true);
			this._$element = $element;

			this._$scrollBarHolder = this._$element.find('.links-wrapper').first();
			this._$scrollBar = this._$scrollBarHolder.find('.scrollbar').first();
			this._$scrollBarItems = this._$scrollBar.find('.scrollbar-link');
			this._$navigationBar = this._$element.find('.navigation-bar').first();
			// this._currentScrollIndex = ( this._$scrollBarItems.filter('.active').index() > 0) ? this._$scrollBarItems.filter('.active').index() : 0;
			this._currentScrollIndex = 0;
			this._stepValue = 0;
			this._maxScrollValue = 0;
			// -1 because the first item has the index 0
			this._maxItems = this._$scrollBarItems.length - 1;

			this._prime();
		}

		return $element;
	}

	(0, _createClass3.default)(MoleculeInPageNavigation, [{
		key: '_prime',
		value: function _prime() {
			var _this = this;

			var _this_ = this,
			    $scrollBar = this._$scrollBar,
			    $scrollBarHolder = this._$scrollBarHolder,
			    visibleArea = 0,
			    maxScrollValue = this._maxScrollValue;

			this._app.registerWaitForWebFontsCallback('initInPageNavigation', function () {
				visibleArea = $scrollBarHolder.outerWidth();

				_this._$scrollBarItems.each(function () {
					maxScrollValue += (0, _shim.jQuery)(this).outerWidth(true);
				});
				maxScrollValue = visibleArea - maxScrollValue;

				_this._showNavigationElements();
				_this._calculateNextScrollBarPosition();
				_this._setScrollBarValue();
			});

			_this_._$navigationBar.find('.arrow').each(function () {
				(0, _shim.jQuery)(this).on('click', function () {
					visibleArea = $scrollBarHolder.outerWidth();
					maxScrollValue = visibleArea - $scrollBar.innerWidth();

					if ((0, _shim.jQuery)(this).hasClass('arrow-left')) {
						_this_._moveLeft(_this_, maxScrollValue);
					} else {
						_this_._moveRight(_this_, maxScrollValue);
					}
				});
			});

			this._$scrollBar.bindSwipeGesture('left', function (e) {
				e.stopPropagation();

				visibleArea = $scrollBarHolder.outerWidth();
				maxScrollValue = visibleArea - $scrollBar.innerWidth();

				_this._moveRight(_this_, maxScrollValue);
			}, 'scrollbarSwipeGesture', 0.05, false);

			this._$scrollBar.bindSwipeGesture('right', function (e) {
				e.stopPropagation();

				visibleArea = $scrollBarHolder.outerWidth();
				maxScrollValue = visibleArea - $scrollBar.innerWidth();

				_this._moveLeft(_this_, maxScrollValue);
			}, 'scrollbarSwipeGesture', 0.05, false);

			this._app.registerResizeCallback(NAME + '-resize-' + this._id, function () {
				(0, _dom.waitForRepaint)(function () {
					_this._showNavigationElements();
					if (!_this._$navigationBar.hasClass('hidden')) {
						_this._setScrollBarValue();
					}
				});
			});

			this._showNavigationElements();

			this._$element.on('move-right', function (e) {
				visibleArea = $scrollBarHolder.outerWidth();
				maxScrollValue = visibleArea - $scrollBar.innerWidth();

				_this._moveRight(_this_, maxScrollValue);
			});

			this._$element.on('move-left', function (e) {
				visibleArea = $scrollBarHolder.outerWidth();
				maxScrollValue = visibleArea - $scrollBar.innerWidth();

				_this._moveLeft(_this_, maxScrollValue);
			});
		}
	}, {
		key: '_showNavigationElements',
		value: function _showNavigationElements() {
			var scrollbarHolderWidth = this._$scrollBarHolder.outerWidth(),
			    maxScrollbarItemsWidth = 0;

			this._$scrollBarItems.each(function () {
				maxScrollbarItemsWidth += (0, _shim.jQuery)(this).outerWidth(true);
			});

			if (maxScrollbarItemsWidth > scrollbarHolderWidth) {
				this._$navigationBar.removeClass('hidden');
			} else {
				this._$navigationBar.addClass('hidden');
				this._$scrollBar.css('left', '0');
			}
		}
	}, {
		key: '_calculateNextScrollBarPosition',
		value: function _calculateNextScrollBarPosition() {
			var maxScrollValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

			if (maxScrollValue) {
				this._stepValue = maxScrollValue;
			} else {
				this._stepValue = 0;
				for (var i = 0; i < this._currentScrollIndex; i++) {
					this._stepValue -= this._$scrollBarItems.eq(i).outerWidth(true);
				}
			}
		}
	}, {
		key: '_setScrollBarValue',
		value: function _setScrollBarValue() {
			this._$scrollBar.css('left', this._stepValue + 1);
		}
	}, {
		key: '_moveLeft',
		value: function _moveLeft(_this_, maxSrollValue) {
			if (_this_._currentScrollIndex > 0) {
				if (_this_._stepValue === maxSrollValue) {
					_this_._calculateNextScrollBarPosition();
					_this_._setScrollBarValue();
				} else {
					_this_._currentScrollIndex--;
					_this_._calculateNextScrollBarPosition();
					_this_._setScrollBarValue();
				}
			}
		}
	}, {
		key: '_moveRight',
		value: function _moveRight(_this_, maxSrollValue) {
			if (_this_._currentScrollIndex < _this_._maxItems && !(_this_._stepValue <= maxSrollValue)) {
				_this_._currentScrollIndex++;
				_this_._calculateNextScrollBarPosition();

				if (_this_._stepValue <= maxSrollValue || _this_._stepValue <= maxSrollValue) {
					_this_._calculateNextScrollBarPosition(maxSrollValue);
				}
				_this_._setScrollBarValue();
				_this_._calculateNextScrollBarPosition();
			}
		}
	}]);
	return MoleculeInPageNavigation;
}();

function init(app) {
	var $elements = (0, _shim.jQuery)();

	(0, _shim.jQuery)(SELECTOR).each(function () {
		var $this = (0, _shim.jQuery)(this);

		$elements = $elements.add(new MoleculeInPageNavigation(app, $this));
	});

	return $elements;
}

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

exports.init = init;

var _shim = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import {generateObjectFitCallback} from 'util/objectfit';


var NAME = 'molecule-3d-viewer',
    SELECTOR = '.' + NAME;

var THREE_JS_SCRIPT_URL = '/js/lib-3d-viewer.js';

var Molecule3DViewer = function () {
	function Molecule3DViewer(app, $element) {
		(0, _classCallCheck3.default)(this, Molecule3DViewer);

		if (!_shim.jQuery.isSet($element.dataDuo('primed'))) {
			$element.dataDuo('primed', true);

			this._app = app;
			this._id = _shim.jQuery.randomUuid(true);
			this._$element = $element;

			this._$previewLayer = this._$element.find('.preview-layer').first();
			// this._$image = this._$previewLayer.find('.image-holder .image img');

			this._$loadingLayer = this._$element.find('.loading-layer').first();
			this._$progress = this._$loadingLayer.find('.progress').first();
			this._$canvas = this._$element.find('.canvas-view').first();

			// this._objectFitCallbackName = null;

			// this._modelScale = this._$element.data('scale');

			this._modelDataPaths = {
				gltf: this._$element.data('source'),
				hdr: this._$element.data('hdr-source')
			};

			this._viewerProps = {
				gltfLoader: null,
				camera: null,
				scene: null,
				renderer: null,
				controls: null
			};

			this._prime();
		}
	}

	(0, _createClass3.default)(Molecule3DViewer, [{
		key: '_prime',
		value: function _prime() {
			var _this = this;

			var _this_ = this;

			// this._objectFitCallbackName = generateObjectFitCallback({
			// 	callbackHandler: function (cb) {
			// 		_this_._app.registerFuzzyUpdateLoopCallback(NAME + '-' + _this_._id, cb);
			// 	},
			// 	$element: this._$image,
			// 	containerSelector: '.image-holder'
			// });

			this._$previewLayer.on('click', function () {
				_shim.jQuery.getScript(THREE_JS_SCRIPT_URL).done(function () {
					_this._initViewer();
				});
			});
		}
	}, {
		key: '_initViewer',
		value: function _initViewer() {
			var _this2 = this;

			var instance = this;
			var THREE = window._THREE;

			if (!THREE) {
				return;
			}

			this._$element.addClass('viewer-loading');

			this._$previewLayer.off('click');

			this._viewerProps.renderer = new THREE.WebGLRenderer({
				canvas: this._$canvas.get(0),
				antialias: true,
				alpha: true
			});

			this._viewerProps.renderer.setSize(this._$element.width(), this._$element.height());
			this._viewerProps.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
			this._viewerProps.renderer.shadowMap.enabled = true;
			this._viewerProps.renderer.gammaOutput = true;

			var fov = 50;
			var aspect = this._$element.width() / this._$element.height();
			var near = 0.01;
			var far = 1000;
			this._viewerProps.camera = new THREE.PerspectiveCamera(fov, aspect, near, far);

			this._viewerProps.camera.position.set(55, 55, 55);

			this._viewerProps.scene = new THREE.Scene();

			this._viewerProps.scene.add(this._viewerProps.camera);

			// Controls
			this._viewerProps.controls = new THREE.OrbitControls(this._viewerProps.camera, this._viewerProps.renderer.domElement);
			this._viewerProps.controls.enabled = true;
			this._viewerProps.controls.panSpeed = 0.8;
			this._viewerProps.controls.minDistance = 30;
			this._viewerProps.controls.minDistance = 30;
			this._viewerProps.controls.maxDistance = 140;

			//lights
			// const ambient = new THREE.AmbientLight( 0xffffff, 3 );
			// this._viewerProps.scene.add( ambient );
			// const hemiLight = new THREE.HemisphereLight( 0xffffff, 0xffffff, 0.8 );
			// hemiLight.position.set( 0, 20, 0 );
			// this._viewerProps.scene.add( hemiLight );
			// const dirLight = new THREE.DirectionalLight( 0xffffff, 60 );
			// // dirLight.position.set( 0, 20, 10 );
			// this._viewerProps.camera.add( dirLight );
			// const light = new THREE.PointLight(0xffffff, 0.8);
			// this._viewerProps.camera.add(light);


			instance._viewerProps.rgbeLoader = new THREE.RGBELoader();

			instance._viewerProps.rgbeLoader.load(instance._modelDataPaths.hdr, function (texture) {
				texture.mapping = THREE.EquirectangularReflectionMapping;
				// instance._viewerProps.scene.background = texture;
				instance._viewerProps.scene.environment = texture;

				instance._viewerProps.gltfLoader = new THREE.GLTFLoader();

				instance._viewerProps.gltfLoader.load(instance._modelDataPaths.gltf, function (object) {
					// if (instance._modelScale) {
					// 	object.scene.scale.set(instance._modelScale, instance._modelScale, instance._modelScale);
					// } else {
					object.scene.scale.set(50, 50, 50);
					// }

					instance._viewerProps.controls.target.copy(object.scene.position);
					instance._viewerProps.scene.add(object.scene);
					instance._$element.removeClass('viewer-loading');
					instance._$element.addClass('viewer-initialized');
					instance._$progress.remove();
				},
				// called when loading is in progresses
				function (xhr) {
					instance._$progress.html(Math.round(xhr.loaded / xhr.total * 100 * 100) / 100 + '% loaded');
				},
				// called when loading has errors
				function (error) {
					console.error('An error happened initializing the 3D viewer:\n', error);
				});

				instance._animateView();
			},
			// called when loading is in progresses
			function (xhr) {
				// instance._$progress.html(Math.round(xhr.loaded / xhr.total * 100 * 100) / 100 + '% loaded');
			},
			// called when loading has errors
			function (error) {
				console.error('An error happened initializing the 3D viewer:\n', error);
			});

			this._app.registerResizeCallback(NAME + '-' + this._id, function () {
				_this2._viewerProps.camera.aspect = _this2._$element.width() / _this2._$element.height();
				_this2._viewerProps.camera.updateProjectionMatrix();

				_this2._viewerProps.renderer.setSize(_this2._$element.width(), _this2._$element.height());
			});
		}
	}, {
		key: '_animateView',
		value: function _animateView() {
			var _this3 = this;

			requestAnimationFrame(function () {
				_this3._animateView();
			});

			this._renderView();
		}
	}, {
		key: '_renderView',
		value: function _renderView() {
			this._viewerProps.camera.updateMatrixWorld();
			this._viewerProps.controls.update();

			this._viewerProps.renderer.render(this._viewerProps.scene, this._viewerProps.camera);
		}
	}]);
	return Molecule3DViewer;
}();

function init(app) {
	var $elements = (0, _shim.jQuery)();

	(0, _shim.jQuery)(SELECTOR).each(function () {
		var $this = (0, _shim.jQuery)(this);
		new Molecule3DViewer(app, $this);
		$elements = $elements.add($this);
	});

	return $elements;
}

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

exports.init = init;

var _shim = __webpack_require__(2);

var _dom = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NAME = 'molecule-video',
    SELECTOR = '.' + NAME;

var MoleculeVideo = function () {
	function MoleculeVideo(app, $element) {
		(0, _classCallCheck3.default)(this, MoleculeVideo);

		if (!_shim.jQuery.isSet($element.dataDuo('primed'))) {
			$element.dataDuo('primed', true);

			this._app = app;
			this._id = _shim.jQuery.randomUuid(true);
			this._$element = $element;

			this._$poster = this._$element.find('.poster').first();
			this._$player = this._$element.find('.player').first();

			this._prime();
		}
	}

	(0, _createClass3.default)(MoleculeVideo, [{
		key: '_prime',
		value: function _prime() {
			var _this = this;

			this._$poster.on('click', function (e) {
				var $template = _this._$player.find('.embed-template');

				_this._$poster.remove();
				_this._$player.append((0, _shim.jQuery)($template.html()));

				$template.remove();
			});

			this._$element.on('reset', function () {
				var html = _this._$player.html();

				(0, _dom.waitForRepaint)(function () {
					_this._$player.empty();

					(0, _dom.waitForRepaint)(function () {
						_this._$player.html(html);
					});
				});
			});
		}
	}]);
	return MoleculeVideo;
}();

function init(app) {
	var $elements = (0, _shim.jQuery)();

	(0, _shim.jQuery)(SELECTOR).each(function () {
		var $this = (0, _shim.jQuery)(this);
		new MoleculeVideo(app, $this);
		$elements = $elements.add($this);
	});

	return $elements;
}

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

exports.init = init;

var _shim = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SELECTOR = '.molecule-google-map';

var MoleculeGoogleMap = function () {
	function MoleculeGoogleMap(app, $element) {
		var _this = this;

		(0, _classCallCheck3.default)(this, MoleculeGoogleMap);

		if (!_shim.jQuery.isSet($element.dataDuo('primed'))) {
			$element.dataDuo('primed', true);

			this._app = app;
			this._id = _shim.jQuery.randomUuid(true);
			this._$element = $element;
			this._$mapWrapper = this._$element.find('.map-wrapper').first();
			this._$map = this._$mapWrapper.find('.map').first();
			this._googleMap = null;
			this._markers = [];
			this._markerCluster = null;
			this._dataUrl = this._$element.dataDuo('url');
			this._defaultLocation = this._$element.dataDuo('location');
			this._defaultInfowindow = this._$element.dataDuo('default-infowindow');

			_shim.jQuery.when(this._app.loadDynamicDependency('GoogleMapsApi', this._dataUrl, 'google.maps')).done(function () {
				_this._googleMapsApi = window.google.maps;
				_this._geoCoder = new _this._googleMapsApi.Geocoder();
				_this._infoWindow = new _this._googleMapsApi.InfoWindow();
				_this._latLngBounds = new _this._googleMapsApi.LatLngBounds();
				_this._prime();
			}).fail(function () {
				throw new Error('GoogleMapsApi could not be loaded');
			});
		}

		return $element;
	}

	(0, _createClass3.default)(MoleculeGoogleMap, [{
		key: '_prime',
		value: function _prime() {
			var _this2 = this;

			var defaultCenter = new this._googleMapsApi.LatLng(0, 0);

			//init the map with initial location
			this._buildMap(defaultCenter);

			this.ucMapProviderDisabled = window.uc.disabledProviders.SCRIPT ? window.uc.disabledProviders.SCRIPT.find(function (item) {
				return item.pid.includes('S1pcEj_jZX');
			}) : false;

			// handle consent layer with uc-block script
			if (!this.ucMapProviderDisabled) {

				_shim.jQuery.when(this._resolveMarkerByAdress(this._defaultLocation)).done(function (result) {
					defaultCenter = result;
				}).always(function () {
					_this2._createMarker(defaultCenter);
				});

				this._$element.on('add-marker', function (e, data) {
					_this2._createMarker(new _this2._googleMapsApi.LatLng(data.location.lat, data.location.lng), data.html);
				});

				this._$element.on('clear-markers', function (e) {
					_this2._clearMarkers();
				});

				this._$element.on('fit-bounds', function (e) {
					_this2._googleMapsApi.event.addListenerOnce(_this2._googleMap, 'bounds_changed', function (event) {
						if (_this2._googleMap.getZoom() > 10) {
							_this2._googleMap.setZoom(10);
						}
					});
					_this2._googleMap.fitBounds(_this2._latLngBounds);
				});
			} else {
				uc.reloadOnOptIn("S1pcEj_jZX"); // reload page on maps opt-in
			}
		}
	}, {
		key: '_buildMap',
		value: function _buildMap(center) {
			this._googleMap = new this._googleMapsApi.Map(this._$map.get(0), {
				mapTypeId: this._googleMapsApi.MapTypeId.ROADMAP,
				mapTypeControl: false,
				mapTypeControlOptions: { style: this._googleMapsApi.MapTypeControlStyle.HORIZONTAL_BAR },
				streetViewControl: false,
				gestureHandling: 'cooperative',
				center: center,
				// zoomControl: false,
				zoom: 4
			});
		}
	}, {
		key: '_resolveMarkerByAdress',
		value: function _resolveMarkerByAdress(address) {
			var deferred = _shim.jQuery.Deferred();

			this._geoCoder.geocode({ 'address': address }, function (results, status) {
				if (status === 'OK') {
					var resultlocation = results[0].geometry.location;
					deferred.resolve({ lat: resultlocation.lat(), lng: resultlocation.lng() });
				} else {
					deferred.reject(new Error('Geocode was not successful for the following reason: ' + status));
				}
			});

			return deferred;
		}
	}, {
		key: '_createMarker',
		value: function _createMarker(markerData, content) {
			var _this3 = this;

			var marker = new this._googleMapsApi.Marker({
				map: this._googleMap,
				position: markerData,
				animation: this._googleMapsApi.Animation.DROP
			});

			this._latLngBounds.extend(marker.getPosition());

			if (_shim.jQuery.isSet(content) && !_shim.jQuery.isEmpty(content)) {
				marker.addListener('click', function () {
					_this3._infoWindow.setContent(content);
					_this3._infoWindow.open(_this3._googleMap, marker);
				});
			}

			this._markers.push(marker);
		}

		// adds markers to the map with setMap GoogleMapsApi method

	}, {
		key: '_setMapOnAll',
		value: function _setMapOnAll(map) {
			for (var i = 0; i < this._markers.length; i++) {
				this._markers[i].setMap(map);
			}
		}
	}, {
		key: '_clearMarkers',
		value: function _clearMarkers() {
			this._setMapOnAll(null);
			this._latLngBounds = new this._googleMapsApi.LatLngBounds();
			this._markers = [];
		}

		// not necessary yet

	}, {
		key: '_showMarkers',
		value: function _showMarkers() {
			this._setMapOnAll(this._googleMap);
		}
	}]);
	return MoleculeGoogleMap;
}();

function init(app) {
	var $elements = (0, _shim.jQuery)();

	(0, _shim.jQuery)(SELECTOR).each(function () {
		var $this = (0, _shim.jQuery)(this);

		$elements = $elements.add(new MoleculeGoogleMap(app, $this));
	});

	return $elements;
}

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

exports.init = init;

var _shim = __webpack_require__(2);

var _objectfit = __webpack_require__(142);

var _dom = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NAME = 'molecule-header-image',
    SELECTOR = '.' + NAME;

var MoleculeHeaderImage = function () {
	function MoleculeHeaderImage(app, $element) {
		(0, _classCallCheck3.default)(this, MoleculeHeaderImage);

		if (!_shim.jQuery.isSet($element.dataDuo('primed'))) {
			$element.dataDuo('primed', true);

			this._app = app;
			this._id = _shim.jQuery.randomUuid(true);
			this._$element = $element;

			this._$image = this._$element.find('picture > img');

			this._objectFitCallbackName = null;

			this._prime();
			$element.dataDuo('primed-ready', true);
		}

		return $element;
	}

	(0, _createClass3.default)(MoleculeHeaderImage, [{
		key: '_prime',
		value: function _prime() {
			var _this_ = this;

			this._objectFitCallbackName = (0, _objectfit.generateObjectFitCallback)({
				callbackHandler: function callbackHandler(cb) {
					cb();
					return _this_._app.registerFuzzyUpdateLoopCallback(NAME + '-' + _this_._id, cb);
				},
				$element: this._$image,
				containerSelector: 'figure',
				position: {
					'top': '50%',
					'left': '50%'
				}
			});
		}
	}]);
	return MoleculeHeaderImage;
}();

function init(app) {
	var $elements = (0, _shim.jQuery)();

	(0, _shim.jQuery)(SELECTOR).each(function () {
		var $this = (0, _shim.jQuery)(this);

		$elements = $elements.add(new MoleculeHeaderImage(app, $this));
	});

	return $elements;
}

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

exports.init = init;

var _shim = __webpack_require__(2);

var _dom = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NAME = 'organism-header-image-homepage',
    SELECTOR = '.' + NAME;

var OrganismHeaderImageHomepage = function () {
	function OrganismHeaderImageHomepage(app, $element) {
		(0, _classCallCheck3.default)(this, OrganismHeaderImageHomepage);

		if (!_shim.jQuery.isSet($element.dataDuo('primed'))) {
			$element.dataDuo('primed', true);

			this._app = app;
			this._id = _shim.jQuery.randomUuid(true);
			this._$element = $element;

			this._$slider = this._$element.find('.image-slider').first();

			this._refreshCallbacks = [];

			this._prime();
		}

		return $element;
	}

	(0, _createClass3.default)(OrganismHeaderImageHomepage, [{
		key: '_prime',
		value: function _prime() {
			var _this = this;

			this._$slider.on('init', function () {
				_this._$slider.removeClass('cloaked');
			}).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
				(0, _shim.jQuery)(slick.$slides.get(currentSlide)).find('.molecule-video').triggerHandler('reset');
			}).slick({
				infinite: true,
				pauseOnHover: true,
				pauseOnFocus: true,
				pauseOnDotsHover: true,
				autoplay: true,
				autoplaySpeed: 6000,
				appendDots: this._$slider,
				dots: true,
				arrows: false,
				mobileFirst: true,
				slidesToShow: 1,
				slidesToScroll: 1
			});

			this._app.registerResizeCallback(NAME + '-resize-' + this._id, function () {
				(0, _dom.waitForRepaint)(function () {
					_shim.lodash.each(_this._refreshCallbacks, function (cb) {
						cb();
					});
				});
			});
			(0, _dom.waitForRepaint)(function () {
				_shim.lodash.each(_this._refreshCallbacks, function (cb) {
					cb();
				});
			});
		}
	}]);
	return OrganismHeaderImageHomepage;
}();

function init(app) {
	var $elements = (0, _shim.jQuery)();

	(0, _shim.jQuery)(SELECTOR).each(function () {
		var $this = (0, _shim.jQuery)(this);

		$elements = $elements.add(new OrganismHeaderImageHomepage(app, $this));
	});

	return $elements;
}

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

exports.init = init;

var _shim = __webpack_require__(2);

var _defines = __webpack_require__(31);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NAME = 'organism-teaser-3-columns',
    SELECTOR = '.' + NAME;

var OrganismTeaser3Columns = function () {
	function OrganismTeaser3Columns(app, $element) {
		(0, _classCallCheck3.default)(this, OrganismTeaser3Columns);

		if (!_shim.jQuery.isSet($element.dataDuo('primed'))) {
			$element.dataDuo('primed', true);

			this._app = app;
			this._id = _shim.jQuery.randomUuid(true);
			this._$element = $element;

			this._$slider = this._$element.find('.slider').first();
			this._$teaserContent = this._$element.find('.slider-content .teaser-content').first();

			this._prime();
		}

		return $element;
	}

	(0, _createClass3.default)(OrganismTeaser3Columns, [{
		key: '_prime',
		value: function _prime() {
			var _this = this;

			var setContent = function setContent(slick, currentSlide) {
				var $slide = (0, _shim.jQuery)(slick.$slides[currentSlide]),
				    $content = $slide.find('.teaser-content');

				_this._$teaserContent.addClass('active');
				_this._$teaserContent.html($content.html());
			};

			this._$slider.slick({
				dots: true,
				arrows: false,
				speed: 500,
				slidesToShow: 1,
				infinite: false,
				mobileFirst: true,
				responsive: [{
					breakpoint: _defines.BREAKPOINT_TABLET - 1,
					settings: {
						slidesToShow: 3,
						dots: false
					}
				}, {
					breakpoint: _defines.BREAKPOINT_DESKTOP + 1,
					settings: {
						slidesToShow: 3
					}
				}]
			}).on('init', function (ev, slick) {
				return setContent(slick, 0);
			}).on('reInit', function (ev, slick) {
				return setContent(slick, 0);
			}).on('afterChange', function (ev, slick, currentSlide) {
				return setContent(slick, currentSlide);
			}).on('beforeChange', function () {
				return _this._$teaserContent.removeClass('active');
			}).slick('slickGoTo', 0);

			this._$element.removeClass('cloaked');
		}
	}]);
	return OrganismTeaser3Columns;
}();

function init(app) {
	var $elements = (0, _shim.jQuery)();

	(0, _shim.jQuery)(SELECTOR).each(function () {
		var $this = (0, _shim.jQuery)(this);

		$elements = $elements.add(new OrganismTeaser3Columns(app, $this));
	});

	return $elements;
}

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

exports.init = init;

var _shim = __webpack_require__(2);

var _defines = __webpack_require__(31);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SELECTOR = '.organism-tab-contentslider-image-text-link';

var OrganismTabContentsliderImageTextLink = function () {
	function OrganismTabContentsliderImageTextLink(app, $element) {
		(0, _classCallCheck3.default)(this, OrganismTabContentsliderImageTextLink);

		if (!_shim.jQuery.isSet($element.dataDuo('primed'))) {
			$element.dataDuo('primed', true);

			this._app = app;
			this._id = _shim.jQuery.randomUuid(true);
			this._$element = $element;

			this._$contentSliderContent = this._$element.find('.contentslider-content').first();
			this._$prevButton = this._$contentSliderContent.find('.prev-button').first();
			this._$nextButton = this._$contentSliderContent.find('.next-button').first();
			this._$contentslider = this._$contentSliderContent.find('.contentslider-slider').first();
			this._$scrollBarHolder = this._$element.find('.links-wrapper').first();
			this._$scrollBar = this._$scrollBarHolder.find('.scrollbar').first();
			this._$scrollbarItems = this._$scrollBar.find('.scrollbar-link');
			this._scrollbarItemsMaxIndex = this._$scrollbarItems.length - 1;
			this._$contentSliderTabNavigation = this._$element.find('.navigation-wrapper .molecule-in-page-navigation').first();

			this._prime();
		}

		return $element;
	}

	(0, _createClass3.default)(OrganismTabContentsliderImageTextLink, [{
		key: '_prime',
		value: function _prime() {
			var _this = this;

			var $contentSlider = this._$contentslider.slick({
				infinite: false,
				dots: false,
				adaptiveHeight: true,
				mobileFirst: true,
				arrows: false,
				prevArrow: this._$prevButton,
				nextArrow: this._$nextButton,
				responsive: [{
					breakpoint: _defines.BREAKPOINT_TABLET,
					settings: {
						arrows: false
					}
				}, {
					breakpoint: _defines.BREAKPOINT_DESKTOP,
					settings: {
						arrows: true
					}
				}]
			}).on('afterChange', function (ev, slick, currentSlide) {
				_this._$scrollbarItems.removeClass('active');
				_this._$scrollbarItems.eq(currentSlide).addClass('active');
			}).on('beforeChange', function (ev, slick, currentSlide, nextSlide) {
				if (currentSlide > nextSlide) {
					_this._$contentSliderTabNavigation.triggerHandler('move-left');
				} else if (currentSlide < nextSlide && nextSlide <= _this._scrollbarItemsMaxIndex) {
					_this._$contentSliderTabNavigation.triggerHandler('move-right');
				}

				// this._previousSlide = currentSlide;
			});

			var addClickHandler = function addClickHandler(index, el) {
				(0, _shim.jQuery)(el).on('click', function () {
					$contentSlider.slick('slickGoTo', (0, _shim.jQuery)(el).index());
				});
			};

			this._$scrollbarItems.each(addClickHandler);
		}
	}]);
	return OrganismTabContentsliderImageTextLink;
}();

function init(app) {
	var $elements = (0, _shim.jQuery)();

	(0, _shim.jQuery)(SELECTOR).each(function () {
		var $this = (0, _shim.jQuery)(this);

		$elements = $elements.add(new OrganismTabContentsliderImageTextLink(app, $this));
	});

	return $elements;
}

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

exports.init = init;

var _shim = __webpack_require__(2);

var _defines = __webpack_require__(31);

var _dom = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SELECTOR = '.organism-product-teaser-list';

var OrganismProductTeaserList = function () {
	function OrganismProductTeaserList(app, $element) {
		(0, _classCallCheck3.default)(this, OrganismProductTeaserList);

		if (!_shim.jQuery.isSet($element.dataDuo('primed'))) {
			$element.dataDuo('primed', true);

			this._app = app;
			this._id = _shim.jQuery.randomUuid(true);
			this._$element = $element;

			this._$teaserGroupWrapper = this._$element.find('.breakout-wrapper .teaser-group-wrapper');
			this._$teaserBackgroundHolder = this._$element.find('.breakout-wrapper .teaser-background-holder');
			this._$teaser = this._$teaserGroupWrapper.find('.molecule-teaser-list-item').first();
			this._$teaserImage = this._$teaser.find('.image-holder').first();
			this._$teaserContent = this._$teaser.find('.content-holder').first();

			this._prime();
		}

		return $element;
	}

	(0, _createClass3.default)(OrganismProductTeaserList, [{
		key: '_prime',
		value: function _prime() {
			var _this = this;

			this._app.registerWaitForWebFontsCallback('product-teaser-list-background-' + this._id, function () {
				(0, _dom.waitForRepaint)(function () {
					_this._setBackgroundPosition();
				});
			});

			this._app.registerResizeCallback('product-teaser-list-background-' + this._id, function () {
				(0, _dom.waitForRepaint)(function () {
					_this._setBackgroundPosition();
				});
			});
		}
	}, {
		key: '_setBackgroundPosition',
		value: function _setBackgroundPosition() {
			if (this._$teaserImage.length > 0) {
				var imageHeight = this._$teaserImage.outerHeight(),
				    backgroundBottomPosition = imageHeight + 50 - 200; // 50px is the stick out value and 200px is the background-gradient height

				this._$teaserBackgroundHolder.css('top', backgroundBottomPosition).removeClass('cloaked');
			}
		}
	}]);
	return OrganismProductTeaserList;
}();

function init(app) {
	var $elements = (0, _shim.jQuery)();

	(0, _shim.jQuery)(SELECTOR).each(function () {
		var $this = (0, _shim.jQuery)(this);

		$elements = $elements.add(new OrganismProductTeaserList(app, $this));
	});

	return $elements;
}

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

exports.init = init;

var _shim = __webpack_require__(2);

var _defines = __webpack_require__(31);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SELECTOR = '.organism-teaserslider-four-columns';

var OrganismTeaserSlider4Columns = function () {
	function OrganismTeaserSlider4Columns(app, $element) {
		(0, _classCallCheck3.default)(this, OrganismTeaserSlider4Columns);

		if (!_shim.jQuery.isSet($element.dataDuo('primed'))) {
			$element.dataDuo('primed', true);

			this._app = app;
			this._id = _shim.jQuery.randomUuid(true);
			this._$element = $element;

			this._$breakoutWrapper = this._$element.find('.breakout-wrapper');
			this._$teaserGroupWrapper = this._$breakoutWrapper.find('.teaser-group-wrapper').first();
			this._$navigationButtonsHolder = this._$breakoutWrapper.find('.navigation-buttons-holder').first();
			this._$prevButton = this._$navigationButtonsHolder.find('.prev-button').first();
			this._$nextButton = this._$navigationButtonsHolder.find('.next-button').first();
			this._$teaserBackgroundHolder = this._$breakoutWrapper.find('.teaser-background-holder').first();
			this._$sliderContent = this._$teaserGroupWrapper.find('.slider-content').first();
			this._$teaser = this._$teaserGroupWrapper.find('.molecule-teaser-list-item').first();
			this._$teaserImage = this._$teaser.find('.image-holder').first();
			this._$teaserContent = this._$teaser.find('.content-holder').first();

			this._prime();
		}

		return $element;
	}

	(0, _createClass3.default)(OrganismTeaserSlider4Columns, [{
		key: '_prime',
		value: function _prime() {
			var _this = this;

			var _$slider = this._$sliderContent.on('init', function () {
				_this._setBackgroundPosition();
				_this._$element.removeClass('cloaked');
			}).slick({
				infinite: false,
				appendDots: this._$teaserBackgroundHolder,
				dots: true,
				arrows: false,
				prevArrow: this._$prevButton,
				nextArrow: this._$nextButton,
				mobileFirst: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				responsive: [{
					breakpoint: _defines.BREAKPOINT_TABLET - 1,
					settings: {
						arrows: false,
						slidesToShow: 2,
						slidesToScroll: 2
					}
				}, {
					breakpoint: _defines.BREAKPOINT_DESKTOP + 1,
					settings: {
						arrows: true,
						slidesToShow: 4,
						slidesToScroll: 4
					}
				}]
			});

			this._app.registerResizeCallback('teaserslider-list-background-' + this._id, function () {
				_$slider.slick('refresh');
				_this._setBackgroundPosition();
			});
		}
	}, {
		key: '_setBackgroundPosition',
		value: function _setBackgroundPosition() {
			if (this._$teaserImage.length > 0) {
				var imageHeight = this._$teaserImage.outerHeight(),
				    backgroundBottomPosition = imageHeight + 50 - 200; // 50px is the stick out value and 200px is the background-gradient height

				this._$teaserBackgroundHolder.css('top', backgroundBottomPosition);
			} else {
				this._$element.addClass('without-img');
			}
		}
	}]);
	return OrganismTeaserSlider4Columns;
}();

function init(app) {
	var $elements = (0, _shim.jQuery)();

	(0, _shim.jQuery)(SELECTOR).each(function () {
		var $this = (0, _shim.jQuery)(this);

		$elements = $elements.add(new OrganismTeaserSlider4Columns(app, $this));
	});

	return $elements;
}

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

exports.init = init;

var _shim = __webpack_require__(2);

var _defines = __webpack_require__(31);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SELECTOR = '.organism-image-fullwidth-textbox';

var OrganismImageFullwidthTextbox = function () {
	function OrganismImageFullwidthTextbox(app, $element) {
		(0, _classCallCheck3.default)(this, OrganismImageFullwidthTextbox);

		if (!_shim.jQuery.isSet($element.dataDuo('primed'))) {
			$element.dataDuo('primed', true);

			this._app = app;
			this._id = _shim.jQuery.randomUuid(true);
			this._$element = $element;

			this._$contentHolder = this._$element.find('.content-holder').first();
			this._$placeholder = this._$element.find('.placeholder').first();
			this._$image = this._$element.find('.atom-image').first();

			this._prime();
		}

		return $element;
	}

	(0, _createClass3.default)(OrganismImageFullwidthTextbox, [{
		key: '_prime',
		value: function _prime() {
			var _this = this;

			this._setContentHolderPosition();

			this._app.registerResizeCallback('image-fullwidth-textbox-' + this._id, function () {
				_this._setContentHolderPosition();
			});
		}
	}, {
		key: '_setContentHolderPosition',
		value: function _setContentHolderPosition() {
			var contentHeight = this._$contentHolder.outerHeight(),
			    imageHeight = this._$image.outerHeight(),
			    vpWidth = window.innerWidth || (0, _shim.jQuery)(window).width();

			if (vpWidth < _defines.BREAKPOINT_TABLET) {
				// minus 50 pixel, because this is the value, which is used to overlay the image
				this._$placeholder.height(contentHeight - 50);
				this._$contentHolder.css('top', imageHeight - 50);
			} else {
				this._$contentHolder.css('top', 'auto');
			}
		}
	}]);
	return OrganismImageFullwidthTextbox;
}();

function init(app) {
	var $elements = (0, _shim.jQuery)();

	(0, _shim.jQuery)(SELECTOR).each(function () {
		var $this = (0, _shim.jQuery)(this);

		$elements = $elements.add(new OrganismImageFullwidthTextbox(app, $this));
	});

	return $elements;
}

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

exports.init = init;

var _shim = __webpack_require__(2);

var _defines = __webpack_require__(31);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SELECTOR = '.organism-key-figures';

var OrganismKeyFigures = function () {
	function OrganismKeyFigures(app, $element) {
		(0, _classCallCheck3.default)(this, OrganismKeyFigures);

		if (!_shim.jQuery.isSet($element.dataDuo('primed'))) {
			$element.dataDuo('primed', true);

			this._app = app;
			this._id = _shim.jQuery.randomUuid(true);
			this._$element = $element;

			this._$contentWrapper = this._$element.find('.content-wrapper');
			this._maxItemCount = this._$contentWrapper.find('.number-holder').length - 1;

			this._prime();
		}

		return $element;
	}

	(0, _createClass3.default)(OrganismKeyFigures, [{
		key: '_prime',
		value: function _prime() {
			this._$contentWrapper.find('.number-holder').each(function () {
				if ((0, _shim.jQuery)(this).index() > 1) {
					(0, _shim.jQuery)(this).addClass('last-item');
				}
			});
		}
	}]);
	return OrganismKeyFigures;
}();

function init(app) {
	var $elements = (0, _shim.jQuery)();

	(0, _shim.jQuery)(SELECTOR).each(function () {
		var $this = (0, _shim.jQuery)(this);

		$elements = $elements.add(new OrganismKeyFigures(app, $this));
	});

	return $elements;
}

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

exports.init = init;

var _shim = __webpack_require__(2);

var _defines = __webpack_require__(31);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SELECTOR = '.organism-vertical-tabs-text-image';

var OrganismVerticalTabsTextImage = function () {
	function OrganismVerticalTabsTextImage(app, $element) {
		(0, _classCallCheck3.default)(this, OrganismVerticalTabsTextImage);

		if (!_shim.jQuery.isSet($element.dataDuo('primed'))) {
			$element.dataDuo('primed', true);

			this._app = app;
			this._id = _shim.jQuery.randomUuid(true);
			this._$element = $element;

			this._$tabNavigation = this._$element.find('.molecule-vertical-tab-navigation').first();
			this._$tabContentWrapper = this._$element.find('.tab-content-wrapper').first();

			this._prime();
		}

		return $element;
	}

	(0, _createClass3.default)(OrganismVerticalTabsTextImage, [{
		key: '_prime',
		value: function _prime() {
			var _this = this;

			var vpWidth = window.innerWidth || (0, _shim.jQuery)(window).width();

			if (vpWidth >= _defines.BREAKPOINT_DESKTOP && !this._$tabNavigation.find('.tab-link').hasClass('active')) {
				this._setFirstItemActive();
			}

			this._initTabNavigation();
			this._initCollapsible();

			(0, _shim.jQuery)(window).on('breakpointchange.app', function (e, oldBreakpoint, newBreakpoint) {
				if (newBreakpoint === 'large') {
					_this._setFirstItemActive();
				}
			});
		}
	}, {
		key: '_setFirstItemActive',
		value: function _setFirstItemActive() {
			this._$tabNavigation.find('.tab-link').removeClass('active');
			this._$tabNavigation.find('.tab-link').first().addClass('active');
			this._$tabContentWrapper.find('.molecule-vertical-tab-content').removeClass('active');
			this._$tabContentWrapper.find('.molecule-vertical-tab-content').first().addClass('active');
		}
	}, {
		key: '_initCollapsible',
		value: function _initCollapsible() {
			var styleResetTimer = _shim.jQuery.schedule(1, _shim.jQuery.noop);

			this._$tabContentWrapper.find('.molecule-vertical-tab-content').children('.collapse-button').on('click', function () {
				var $parent = (0, _shim.jQuery)(this).parent(),
				    $content = (0, _shim.jQuery)(this).siblings('.content-body').first(),
				    contentHeight = 0;

				if (!$parent.hasClass('active')) {
					$content.css('height', 'auto');
				}

				contentHeight = $content.outerHeight();

				if (!$parent.hasClass('active')) {
					$content.css('height', '0');
				} else {
					$content.css('height', contentHeight);
				}

				$parent.addClass('collapsible-collapsing');

				_shim.jQuery.schedule(25, function () {
					if (!$parent.hasClass('active')) {
						$content.css('height', contentHeight);
					} else {
						$content.css('height', '0');
					}

					$parent.toggleClass('active');

					styleResetTimer = _shim.jQuery.reschedule(styleResetTimer, 250, function () {
						$parent.removeClass('collapsible-collapsing');
						$content.css('height', '');
					});
				});
			});
		}
	}, {
		key: '_initTabNavigation',
		value: function _initTabNavigation() {
			var _this2 = this;

			this._$tabNavigation.find('.tab-link').on('click', function (event) {
				var currentIndex = (0, _shim.jQuery)(event.currentTarget).index();

				_this2._$tabNavigation.find('.tab-link').removeClass('active');
				(0, _shim.jQuery)(event.currentTarget).addClass('active');

				_this2._$tabContentWrapper.find('.molecule-vertical-tab-content').removeClass('active');
				_this2._$tabContentWrapper.find('.molecule-vertical-tab-content').eq(currentIndex).addClass('active').stop(true).css({ opacity: 0.0 }).animate({ opacity: 1.0 }, 500);
			});
		}
	}]);
	return OrganismVerticalTabsTextImage;
}();

function init(app) {
	var $elements = (0, _shim.jQuery)();

	(0, _shim.jQuery)(SELECTOR).each(function () {
		var $this = (0, _shim.jQuery)(this);

		$elements = $elements.add(new OrganismVerticalTabsTextImage(app, $this));
	});

	return $elements;
}

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

exports.init = init;

var _shim = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SELECTOR = '.organism-collapsible';

var OrganismCollapsible = function () {
	function OrganismCollapsible(app, $element) {
		(0, _classCallCheck3.default)(this, OrganismCollapsible);

		if (!_shim.jQuery.isSet($element.dataDuo('primed'))) {
			$element.dataDuo('primed', true);

			this._app = app;
			this._id = _shim.jQuery.randomUuid(true);
			this._$element = $element;

			this._$tabContentWrapper = this._$element.find('.tab-content-wrapper').first();

			this._prime();
		}

		return $element;
	}

	(0, _createClass3.default)(OrganismCollapsible, [{
		key: '_prime',
		value: function _prime() {
			this._initCollapsible();
		}
	}, {
		key: '_initCollapsible',
		value: function _initCollapsible() {
			var styleResetTimer = _shim.jQuery.schedule(1, _shim.jQuery.noop);

			this._$tabContentWrapper.find('.tab').children('.collapse-button').on('click', function () {
				var $parent = (0, _shim.jQuery)(this).parent(),
				    $content = (0, _shim.jQuery)(this).siblings('.content').first(),
				    contentHeight = 0;

				if (!$parent.hasClass('active')) {
					$content.css('height', 'auto');
				}

				contentHeight = $content.outerHeight();

				if (!$parent.hasClass('active')) {
					$content.css('height', '0');
				} else {
					$content.css('height', contentHeight);
				}

				$parent.addClass('collapsible-collapsing');

				_shim.jQuery.schedule(25, function () {
					if (!$parent.hasClass('active')) {
						$content.css('height', contentHeight);
					} else {
						$content.css('height', '0');
					}

					$parent.toggleClass('active');

					styleResetTimer = _shim.jQuery.reschedule(styleResetTimer, 250, function () {
						$parent.removeClass('collapsible-collapsing');
						$content.css('height', '');
					});
				});
			});
		}
	}]);
	return OrganismCollapsible;
}();

function init(app) {
	var $elements = (0, _shim.jQuery)();

	(0, _shim.jQuery)(SELECTOR).each(function () {
		var $this = (0, _shim.jQuery)(this);

		$elements = $elements.add(new OrganismCollapsible(app, $this));
	});

	return $elements;
}

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

exports.init = init;

var _shim = __webpack_require__(2);

var _objectfit = __webpack_require__(142);

var _dom = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NAME = 'organism-breakout-image-tab-teaser',
    SELECTOR = '.' + NAME;

var OrganismBreakoutImageTabTeaser = function () {
	function OrganismBreakoutImageTabTeaser(app, $element) {
		(0, _classCallCheck3.default)(this, OrganismBreakoutImageTabTeaser);

		if (!_shim.jQuery.isSet($element.dataDuo('primed'))) {
			$element.dataDuo('primed', true);

			this._app = app;
			this._id = _shim.jQuery.randomUuid(true);
			this._$element = $element;

			this._$mobileVersion = this._$element.find('.mobile-version').first();
			this._$sliderMobile = this._$mobileVersion.find('.image-slider').first();
			this._$slickTrackMobile = (0, _shim.jQuery)();
			this._$slickSlidesMobile = (0, _shim.jQuery)();
			this._$silderImgsMobile = (0, _shim.jQuery)();
			this._$tabletDesktopVersion = this._$element.find('.tablet-desktop-version').first();
			this._$sliderTabletDesktop = this._$tabletDesktopVersion.find('.image-slider').first();
			this._$slidesTabletDesktop = this._$sliderTabletDesktop.find('.slide');
			this._$silderImgsTabletDesktop = this._$sliderTabletDesktop.find('picture > img');
			this._$teasersTabletDesktop = this._$tabletDesktopVersion.find('.teasers > .teaser');

			this._refreshCallbacks = [];
			this._sliderMobileReady = _shim.jQuery.Deferred();
			this._sliderTabletDesktopReady = _shim.jQuery.Deferred();

			this._prime();
		}

		return $element;
	}

	(0, _createClass3.default)(OrganismBreakoutImageTabTeaser, [{
		key: '_prime',
		value: function _prime() {
			var _this = this;

			var _this_ = this;

			this._$mobileVersion.addClass('ready');
			(0, _dom.waitForRepaint)(function () {
				_this._$sliderMobile.on('init', function () {
					_this._$slickTrackMobile = _this._$sliderMobile.find('.slick-track').first();
					_this._$slickSlidesMobile = _this._$slickTrackMobile.find('.slick-slide');
					_this._$silderImgsMobile = _this._$sliderMobile.find('picture > img');

					_this._$silderImgsMobile.each(function () {
						_this_._refreshCallbacks.push((0, _objectfit.generateObjectFitCallback)({
							callbackHandler: function callbackHandler(cb) {
								return cb;
							},
							$element: (0, _shim.jQuery)(this),
							containerSelector: 'figure',
							position: {
								'top': '50%',
								'left': '50%'
							}
						}));
					});

					_this._refreshCallbacks.push(_shim.lodash.debounce(function () {
						_this._$slickSlidesMobile.css('height', '');

						(0, _dom.waitForRepaint)(function () {
							_this._$slickSlidesMobile.css('height', _this._$slickTrackMobile.outerHeight());
						});
					}, 500));

					_this._sliderMobileReady.resolve();
				}).on('afterChange', function (e, slick, currentSlide) {
					_this._$teasersTabletDesktop.eq(currentSlide).triggerHandler('click');
				}).slick({
					infinite: false,
					appendDots: _this._$sliderMobile,
					dots: true,
					arrows: false,
					mobileFirst: true,
					slidesToShow: 1,
					slidesToScroll: 1
				});
			});

			this._$silderImgsTabletDesktop.each(function () {
				_this_._refreshCallbacks.push((0, _objectfit.generateObjectFitCallback)({
					callbackHandler: function callbackHandler(cb) {
						return cb;
					},
					$element: (0, _shim.jQuery)(this),
					containerSelector: 'figure',
					position: {
						'top': '50%',
						'left': '50%'
					}
				}));
			});

			this._$teasersTabletDesktop.on('click', function (e) {
				e.preventDefault();

				var index = (0, _shim.jQuery)(this).index();

				_this_._$slidesTabletDesktop.removeClass('active').eq(index).addClass('active').end();

				_this_._$teasersTabletDesktop.removeClass('active');
				(0, _shim.jQuery)(this).addClass('active');

				if (_this_._sliderMobileReady.state() === 'resolved') {
					_this_._$sliderMobile.slick('slickGoTo', index, true);
				}
			}).find('a').on('click', function (e) {
				e.stopPropagation();
			}).end();

			this._app.registerResizeCallback(NAME + '-resize-' + this._id, function () {
				_this._refresh();
			});
			this._refresh(function () {
				_this._sliderTabletDesktopReady.resolve();
			});

			_shim.jQuery.when(this._sliderMobileReady, this._sliderTabletDesktopReady).done(function () {
				_this._$element.removeClass('cloaked');
				_this._refresh();
			});
		}
	}, {
		key: '_refresh',
		value: function _refresh(afterRefreshCallback) {
			var _this2 = this;

			afterRefreshCallback = _shim.jQuery.orDefault(afterRefreshCallback, _shim.jQuery.noop);

			(0, _dom.waitForRepaint)(function () {
				_shim.lodash.each(_this2._refreshCallbacks, function (cb) {
					cb();
				});
				afterRefreshCallback();
			});
		}
	}]);
	return OrganismBreakoutImageTabTeaser;
}();

function init(app) {
	var $elements = (0, _shim.jQuery)();

	(0, _shim.jQuery)(SELECTOR).each(function () {
		var $this = (0, _shim.jQuery)(this);

		$elements = $elements.add(new OrganismBreakoutImageTabTeaser(app, $this));
	});

	return $elements;
}

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

exports.init = init;

var _shim = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SELECTOR = '.organism-product-intro';

var OrganismProductIntro = function () {
	function OrganismProductIntro(app, $element) {
		(0, _classCallCheck3.default)(this, OrganismProductIntro);

		if (!_shim.jQuery.isSet($element.dataDuo('primed'))) {
			$element.dataDuo('primed', true);

			this._app = app;
			this._id = _shim.jQuery.randomUuid(true);
			this._$element = $element;

			this._$slider = this._$element.find('.image-slider').first();

			this._refreshCallbacks = [];

			this._prime();
		}

		return $element;
	}

	(0, _createClass3.default)(OrganismProductIntro, [{
		key: '_prime',
		value: function _prime() {
			var _this = this;

			this._$slider.on('init', function () {
				_this._$slider.removeClass('cloaked');
			}).slick({
				infinite: true,
				pauseOnHover: true,
				pauseOnFocus: true,
				pauseOnDotsHover: true,
				autoplay: true,
				autoplaySpeed: 6000,
				appendDots: this._$slider,
				dots: true,
				arrows: false,
				mobileFirst: true,
				slidesToShow: 1,
				slidesToScroll: 1
			});

			this._app.registerResizeCallback(NAME + '-resize-' + this._id, function () {
				waitForRepaint(function () {
					_.each(_this._refreshCallbacks, function (cb) {
						cb();
					});
				});
			});
			waitForRepaint(function () {
				_.each(_this._refreshCallbacks, function (cb) {
					cb();
				});
			});
		}
	}]);
	return OrganismProductIntro;
}();

function init(app) {
	var $elements = (0, _shim.jQuery)();

	(0, _shim.jQuery)(SELECTOR).each(function () {
		var $this = (0, _shim.jQuery)(this);

		$elements = $elements.add(new OrganismProductIntro(app, $this));
	});

	return $elements;
}

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _defineProperty2 = __webpack_require__(143);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

exports.init = init;

var _shim = __webpack_require__(2);

var _context = __webpack_require__(37);

var _dom = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NAME = 'organism-filterbox-3-columns',
    SELECTOR = '.' + NAME,
    FILTER_INPUTS_SELECTOR = ':input, select, :text, textarea',
    SUBMIT_MODE_ASYNC = 'async',
    SUBMIT_MODE_SYNC = 'sync',
    SUBMIT_MODES = [SUBMIT_MODE_ASYNC, SUBMIT_MODE_SYNC];

var OrganismFilterbox3Columns = function () {
	function OrganismFilterbox3Columns(app, $element) {
		(0, _classCallCheck3.default)(this, OrganismFilterbox3Columns);

		if (!_shim.jQuery.isSet($element.dataDuo('primed'))) {
			$element.dataDuo('primed', true);

			this._app = app;
			this._id = _shim.jQuery.randomUuid(true);
			this._$element = $element;

			this._$filterForm = this._$element.find('.filter-form').first();
			this._$filters = this._$filterForm.find('.filters .filter');
			this._$resetButton = this._$element.find('.buttons .reset');
			this._$submitButton = this._$element.find('.buttons .submit');

			this._originalSubmitCaption = this._$submitButton.text();

			this._submitResultCaptionSingularTemplate = _shim.jQuery.isSet(this._$element.data('submit-result-caption-singular-template')) ? this._$element.data('submit-result-caption-singular-template') : 'Show {count} result';
			this._submitResultCaptionPluralTemplate = _shim.jQuery.isSet(this._$element.data('submit-result-caption-plural-template')) ? this._$element.data('submit-result-caption-plural-template') : 'Show {count} results';
			this._submitNoResultCaptionTemplate = _shim.jQuery.isSet(this._$element.data('submit-no-result-caption-template')) ? this._$element.data('submit-no-result-caption-template') : 'No results to show';

			// detect if form should submit via event with payload (async) or with browser default and reload (sync)
			this._submitMode = _shim.jQuery.isSet(this._$element.data('submit-mode')) && _shim.lodash.includes(SUBMIT_MODES, this._$element.data('data-submit-mode')) ? this._$element.data('data-submit-mode') : SUBMIT_MODE_ASYNC;

			// needs to be before prime()
			this._refreshFilterValues();
			this._prime();
			this._initPatternLabDemoBehaviour();
		}

		return $element;
	}

	(0, _createClass3.default)(OrganismFilterbox3Columns, [{
		key: '_prime',
		value: function _prime() {
			var _this = this;

			this._$filters.find(FILTER_INPUTS_SELECTOR).on('change', function () {
				_this._refreshFilterValues();

				if (_this._anyFiltersSet) {
					_this._$resetButton.enable();
					_this._$submitButton.enable();
				} else {
					_this._$resetButton.disable();
					_this._$submitButton.disable();
				}

				_this._$element.triggerHandler('filterschanged.app', { filters: _this._formData });
			});

			this._$resetButton.disable().on('click', function (e) {
				e.preventDefault();

				if (_this._anyFiltersSet) {
					_this._$filters.find(FILTER_INPUTS_SELECTOR).each(function () {
						if ((0, _shim.jQuery)(this).is('select')) {
							(0, _shim.jQuery)(this).val((0, _shim.jQuery)(this).find('option').first().attr('value'));

							if (_shim.jQuery.isFunction((0, _shim.jQuery)(this).selectric)) {
								(0, _shim.jQuery)(this).selectric('refresh');
							}
						} else if ((0, _shim.jQuery)(this).is(':checkbox, :radio')) {
							(0, _shim.jQuery)(this).uncheck().trigger('init.stylableinput');
						} else if ((0, _shim.jQuery)(this).is(':text, textarea')) {
							(0, _shim.jQuery)(this).val('');
						} else {
							(0, _shim.jQuery)(this).val('');
						}
					});

					_this._refreshFilterValues();
					_this._$resetButton.disable();
					_this._$submitButton.enable();
					_this._$element.triggerHandler('filterschanged.app', { filters: _this._formData, reset: true });
				}
			});

			this._$submitButton.disable();

			this._$filterForm.on('submit', function (e) {
				switch (_this._submitMode) {
					case SUBMIT_MODE_SYNC:
						// use browser default behaviour, but keep event from bubbling back to the element resulting in a loop
						e.stopPropagation();
						break;

					case SUBMIT_MODE_ASYNC:
					default:
						e.preventDefault();
						e.stopPropagation();

						_this._$submitButton.disable();

						_this._$element.triggerHandler('submitted.app', { filters: _this._formData });
						break;
				}
			});

			this._$element
			// if a submit is triggered manually by an event on the organism, just submit the form and let its handler deal with it
			.on('submit.app', function () {
				_this._$filterForm.submit();
			})

			// request a "serialized" event containing the current formdata as payload
			.on('serialize.app', function () {
				_this._refreshFilterValues();
				_this._$element.triggerHandler('serialized.app', { filters: _this._formData });
			}).on('updatefilterdata.app', function (e, data) {
				if (_shim.jQuery.isSet(data.count)) {
					var count = parseInt(data.count, 10);

					if (count > 0) {
						_this._$submitButton.text(_shim.jQuery.strFormat(count === 1 ? _this._submitResultCaptionSingularTemplate : _this._submitResultCaptionPluralTemplate, { count: count }));

						if (!data.keepSubmitState) {
							_this._$submitButton.enable();
						}
					} else {
						_this._$submitButton.text(_this._submitNoResultCaptionTemplate);

						if (!data.keepSubmitState) {
							_this._$submitButton.disable();
						}
					}
				} else {
					_this._$submitButton.text(_this._originalSubmitCaption);

					if (!data.keepSubmitState) {
						_this._$submitButton.disable();
					}
				}

				if (_shim.jQuery.isPlainObject(data.filters)) {
					if (data.mode === 'from-scratch') {
						_this._$filters.find('[name]').each(function () {
							var name = (0, _shim.jQuery)(this).attr('name');

							if (!_shim.jQuery.isSet(data.filters[name])) {
								data.filters[name] = '';
							}
						});
					}

					_shim.lodash.each(data.filters, function (value, filterName) {
						_this._$filterForm.find('[name="' + filterName + '"]').each(function () {
							var _this2 = this;

							if ((0, _shim.jQuery)(this).is('select')) {
								var options = _shim.jQuery.isArray(value) ? value : [value],
								    currentVal = (0, _shim.jQuery)(this).val();

								(0, _shim.jQuery)(this).children('option[value!=""]').remove();
								_shim.lodash.each(options, function (option) {
									if (_shim.jQuery.isSet(option.value, option.text)) {
										(0, _shim.jQuery)(_this2).append((0, _shim.jQuery)('<option value="' + option.value + '">' + option.text + '</option>'));
									}
								});

								(0, _dom.waitForRepaint)(function () {
									(0, _shim.jQuery)(_this2).val(currentVal);

									if (_shim.jQuery.isFunction((0, _shim.jQuery)(_this2).selectric)) {
										(0, _shim.jQuery)(_this2).selectric('refresh');

										if (_shim.jQuery.isEmpty((0, _shim.jQuery)(_this2).val())) {
											var $label = (0, _shim.jQuery)(_this2).parent('.selectric-hide-select').siblings('.selectric').find('.label');
											if (!_shim.jQuery.exists($label.children('.default'))) {
												$label.html('<span class="default">' + $label.text() + '</span>');
											}
										}
									}
								});
							} /*if( $(this).is(':checkbox, :radio') ){
         if( !!value ){
         $(this).check();
         } else {
         $(this).uncheck();
         }
         } if( $(this).is(':text, textarea') ){
         $(this).val(''+value);
         } else {
         $(this).val(''+value);
         }*/
						});
					});

					(0, _dom.waitForRepaint)(function () {
						_this._refreshFilterValues();
						if (!_this._anyFiltersSet) {
							_this._$resetButton.disable();
						}
					});
				}
			});

			_shim.lodash.defer(function () {
				_this._$element.triggerHandler('initialized.app', { filters: _this._formData });
			});
		}
	}, {
		key: '_refreshFilterValues',
		value: function _refreshFilterValues() {
			this._formData = this._$filterForm.formDataToObject();
			this._cleanFilterValues();
			this._anyFiltersSet = !!_shim.lodash.size(this._formData);
		}
	}, {
		key: '_cleanFilterValues',
		value: function _cleanFilterValues() {
			var formData = {};

			_shim.lodash.each(this._formData, function (value, key) {
				if (_shim.lodash.trim(value) !== '') {
					formData[key] = value;
				}
			});

			this._formData = formData;
		}
	}, {
		key: '_initPatternLabDemoBehaviour',
		value: function _initPatternLabDemoBehaviour() {
			var _this3 = this;

			if ((_context.Context.get('runningInPatternLabList') || _context.Context.get('runningInPatternLabDetails')) && this._$element.parent().closest('[class^="organism-"]').length === 0) {
				this._$element.on('filterschanged.app', function (e, data) {
					if (!data.reset) {
						var emptyFilters = _shim.lodash.random(0, 5) === 0,
						    values = [_shim.lodash.random(10, 99), _shim.lodash.random(10, 99), _shim.lodash.random(10, 99)];

						_this3._$element.triggerHandler('updatefilterdata.app', {
							count: !emptyFilters ? _shim.lodash.random(1, 999) : 0,
							mode: !emptyFilters ? 'additive' : 'from-scratch',
							filters: !emptyFilters ? (0, _defineProperty3.default)({}, 'filter' + _shim.lodash.random(1, 4), [{
								value: values[0],
								text: 'Filter ' + values[0]
							}, {
								value: values[1],
								text: 'Filter ' + values[1] + ' Filter ' + values[1] + ' Filter ' + values[1]
							}, {
								value: values[2],
								text: 'Filter ' + values[2] + ' Filter ' + values[2]
							}]) : {}
						});
					}
				}).on('initialized.app', function (e, data) {
					_shim.jQuery.log('OrganismFilterbox3Columns -> initialized.app', data.filters);
				}).on('submitted.app', function (e, data) {
					_shim.jQuery.log('OrganismFilterbox3Columns -> submitted.app', data.filters);
				});
			}
		}
	}]);
	return OrganismFilterbox3Columns;
}();

function init(app) {
	var $elements = (0, _shim.jQuery)();

	(0, _shim.jQuery)(SELECTOR).each(function () {
		var $this = (0, _shim.jQuery)(this);

		$elements = $elements.add(new OrganismFilterbox3Columns(app, $this));
	});

	return $elements;
}

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

exports.init = init;

var _shim = __webpack_require__(2);

var _context = __webpack_require__(37);

var _dom = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NAME = 'organism-filtered-download-list',
    SELECTOR = '.' + NAME;

var OrganismFilteredDownloadList = function () {
	function OrganismFilteredDownloadList(app, $element) {
		(0, _classCallCheck3.default)(this, OrganismFilteredDownloadList);

		if (!_shim.jQuery.isSet($element.dataDuo('primed'))) {
			$element.dataDuo('primed', true);

			this._app = app;
			this._id = _shim.jQuery.randomUuid(true);
			this._$element = $element;

			this._$filterbox = this._$element.find('.filterbox').first();
			this._$listHeadline = this._$element.find('.list-headline');
			this._$downloadList = this._$element.find('.download-list').first();
			this._$downloadHolder = this._$downloadList.find('.teaser-holder').first();
			this._$showMoreButton = this._$downloadList.find('.cta').first().disable();

			this._downloadsInitialCount = _shim.jQuery.isSet(this._$element.data('downloads-initial-count')) ? this._$element.data('downloads-initial-count') : 12;
			this._downloadsShowMoreCount = _shim.jQuery.isSet(this._$element.data('downloads-show-more-count')) ? this._$element.data('downloads-show-more-count') : 12;
			this._headlineFilteredSingularTemplate = _shim.jQuery.isSet(this._$element.data('headline-filtered-singular-template')) ? this._$element.data('headline-filtered-singular-template') : 'Download ({count})';
			this._headlineFilteredPluralTemplate = _shim.jQuery.isSet(this._$element.data('headline-filtered-plural-template')) ? this._$element.data('headline-filtered-plural-template') : 'Downloads ({count})';

			this._downloadTemplate = this._$element.find('.download-template').html();
			this._downloadsUrl = this._$element.data('downloads-url');
			_shim.jQuery.assert(_shim.jQuery.isSet(this._downloadsUrl, 'OrganismFilteredDownloadList.constructor | no downloads url has been provided'));
			this._downloadsJson = null;
			this._fittingDownloads = null;
			this._currentFilterTags = {};
			this._upperDownloadIndexShown = -1;

			this._prime();
		}

		return $element;
	}

	(0, _createClass3.default)(OrganismFilteredDownloadList, [{
		key: '_prime',
		value: function _prime() {
			var _this = this;

			_shim.jQuery.getJSON(this._downloadsUrl, function (downloadsJson) {
				_shim.jQuery.assert(_shim.jQuery.isArray(downloadsJson), 'OrganismFilteredDownloadList._prime | downloads json must be an array of objects');
				_this._downloadsJson = downloadsJson;
				_this._refreshFilterTags(_this._downloadsJson);
				_this._updateFilterbox(false, true);
				_this._$element.removeClass('loading');
			});

			this._$filterbox.on('filterschanged.app', function (e, data) {
				var filters = data.filters;

				_this._fittingDownloads = _shim.lodash.filter(_this._downloadsJson, function (download) {
					var res = true;

					_shim.lodash.each(filters, function (filterValue, filterName) {
						if (!_shim.jQuery.isSet(download.filterAttributes) || !_shim.jQuery.isSet(download.filterAttributes[filterName]) || !_shim.jQuery.isSet(download.filterAttributes[filterName].value) && !_shim.jQuery.isArray(download.filterAttributes[filterName].values) || filterValue !== download.filterAttributes[filterName].value && !_shim.lodash.includes(download.filterAttributes[filterName].values, filterValue)) {
							res = false;
							return false;
						}
					});

					return res;
				});

				_this._refreshFilterTags(_this._fittingDownloads);
				_this._updateFilterbox();
			});

			this._$filterbox.on('submitted.app', function () {
				var newUpperIndex = _this._downloadsInitialCount - 1;

				_this._$downloadHolder.empty();
				_this._upperDownloadIndexShown = -1;
				_this._showDownloads(newUpperIndex);

				_this._$element.addClass('filtered');

				_this._$listHeadline.text(_shim.jQuery.strFormat(_shim.lodash.size(_this._fittingDownloads) === 1 ? _this._headlineFilteredSingularTemplate : _this._headlineFilteredPluralTemplate, { count: _shim.lodash.size(_this._fittingDownloads) }));
			});

			this._$showMoreButton.on('click', function (e) {
				e.preventDefault();

				var newUpperIndex = _this._upperDownloadIndexShown + _this._downloadsShowMoreCount;

				_this._showDownloads(newUpperIndex);
			});
		}
	}, {
		key: '_refreshFilterTags',
		value: function _refreshFilterTags(downloads) {
			var _this2 = this;

			this._currentFilterTags = {};

			var currentFilterTagsMap = {};

			_shim.lodash.each(downloads, function (download) {
				_shim.lodash.each(download.filterAttributes, function (filterTag, filterName) {
					if (!_shim.jQuery.isSet(currentFilterTagsMap[filterName])) {
						currentFilterTagsMap[filterName] = {
							values: [],
							textMap: {}
						};
					}

					if (_shim.jQuery.isSet(filterTag.value, filterTag.text)) {
						currentFilterTagsMap[filterName].values.push(filterTag.value);
						currentFilterTagsMap[filterName].textMap[filterTag.value] = filterTag.text;
					}

					if (_shim.jQuery.isArray(filterTag.values) && _shim.jQuery.isArray(filterTag.texts)) {
						_shim.lodash.each(filterTag.values, function (value, index) {
							currentFilterTagsMap[filterName].values.push(value);
							currentFilterTagsMap[filterName].textMap[value] = filterTag.texts[index];
						});
					}
				});
			});

			_shim.lodash.each(currentFilterTagsMap, function (map, filterName) {
				_shim.lodash.each(_shim.lodash.uniq(map.values), function (value) {
					if (!_shim.jQuery.isSet(_this2._currentFilterTags[filterName])) {
						_this2._currentFilterTags[filterName] = [];
					}

					_this2._currentFilterTags[filterName].push({
						value: value,
						text: map.textMap[value]
					});
				});

				_this2._currentFilterTags[filterName] = _shim.lodash.sortBy(_this2._currentFilterTags[filterName], ['text']);
			});
		}
	}, {
		key: '_updateFilterbox',
		value: function _updateFilterbox(onlyCount, init) {
			if (init) {
				this._$filterbox.triggerHandler('updatefilterdata.app', {
					mode: 'from-scratch',
					filters: this._currentFilterTags
				});
			} else if (onlyCount) {
				this._$filterbox.triggerHandler('updatefilterdata.app', {
					count: _shim.lodash.size(this._fittingDownloads)
				});
			} else {
				this._$filterbox.triggerHandler('updatefilterdata.app', {
					count: _shim.lodash.size(this._fittingDownloads),
					mode: 'from-scratch',
					filters: this._currentFilterTags
				});
			}
		}
	}, {
		key: '_showDownloads',
		value: function _showDownloads(newUpperIndex) {
			var _this3 = this;

			var lastIndex = this._upperDownloadIndexShown;

			_shim.lodash.each(this._fittingDownloads, function (download, index) {
				if (index > _this3._upperDownloadIndexShown) {
					if (index > newUpperIndex) {
						return false;
					}

					var $newDownload = (0, _shim.jQuery)(_shim.jQuery.strFormat(_this3._downloadTemplate, {
						url: download.url,
						image_alt: download.image.alt,
						image_desktop: download.image.sources.desktop,
						image_tablet: download.image.sources.tablet,
						image_mobile: download.image.sources.mobile,
						image_default: download.image.sources.default,
						subheadline: download.subheadline,
						headline: download.headline,
						copytext: download.copytext
					}));

					if (_shim.jQuery.isEmpty(download.subheadline)) {
						$newDownload.find('.subheadline').remove();
					}

					if (_shim.jQuery.isEmpty(download.copytext)) {
						$newDownload.find('.copytext').remove();
					}

					$newDownload.addClass('preparing');
					_this3._$downloadHolder.append($newDownload);
					(0, _dom.waitForRepaint)(function () {
						$newDownload.removeClass('preparing');
					});

					lastIndex = index;
				}
			});

			this._upperDownloadIndexShown = lastIndex;
			if (_shim.lodash.size(this._fittingDownloads) > this._upperDownloadIndexShown + 1) {
				this._$showMoreButton.enable();
			} else {
				this._$showMoreButton.disable();
			}
		}
	}]);
	return OrganismFilteredDownloadList;
}();

function init(app) {
	var $elements = (0, _shim.jQuery)();

	(0, _shim.jQuery)(SELECTOR).each(function () {
		var $this = (0, _shim.jQuery)(this);

		$elements = $elements.add(new OrganismFilteredDownloadList(app, $this));
	});

	return $elements;
}

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _defineProperty2 = __webpack_require__(143);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

exports.init = init;

var _shim = __webpack_require__(2);

var _context = __webpack_require__(37);

var _dom = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NAME = 'organism-filterbox-locations',
    SELECTOR = '.' + NAME,
    FILTER_INPUTS_SELECTOR = ':input, select, :text, textarea',
    SUBMIT_MODE_ASYNC = 'async',
    SUBMIT_MODE_SYNC = 'sync',
    SUBMIT_MODES = [SUBMIT_MODE_ASYNC, SUBMIT_MODE_SYNC];

var OrganismFilterboxLocations = function () {
	function OrganismFilterboxLocations(app, $element) {
		(0, _classCallCheck3.default)(this, OrganismFilterboxLocations);

		if (!_shim.jQuery.isSet($element.dataDuo('primed'))) {
			$element.dataDuo('primed', true);

			this._app = app;
			this._id = _shim.jQuery.randomUuid(true);
			this._$element = $element;

			this._$filterForm = this._$element.find('.filter-form').first();
			this._$filters = this._$filterForm.find('.filters .filter');
			this._$resetButton = this._$element.find('.buttons .reset');
			this._$submitButton = this._$element.find('.buttons .submit');

			this._originalSubmitCaption = this._$submitButton.text();

			this._submitResultCaptionSingularTemplate = _shim.jQuery.isSet(this._$element.data('submit-result-caption-singular-template')) ? this._$element.data('submit-result-caption-singular-template') : 'Show {count} result';
			this._submitResultCaptionPluralTemplate = _shim.jQuery.isSet(this._$element.data('submit-result-caption-plural-template')) ? this._$element.data('submit-result-caption-plural-template') : 'Show {count} results';
			this._submitNoResultCaptionTemplate = _shim.jQuery.isSet(this._$element.data('submit-no-result-caption-template')) ? this._$element.data('submit-no-result-caption-template') : 'No results to show';

			// detect if form should submit via event with payload (async) or with browser default and reload (sync)
			this._submitMode = _shim.jQuery.isSet(this._$element.data('submit-mode')) && _shim.lodash.includes(SUBMIT_MODES, this._$element.data('data-submit-mode')) ? this._$element.data('data-submit-mode') : SUBMIT_MODE_ASYNC;

			// needs to be before prime()
			this._refreshFilterValues();
			this._prime();
			this._initPatternLabDemoBehaviour();
		}

		return $element;
	}

	(0, _createClass3.default)(OrganismFilterboxLocations, [{
		key: '_prime',
		value: function _prime() {
			var _this = this;

			this._$filters.find(FILTER_INPUTS_SELECTOR).on('change', function () {
				_this._refreshFilterValues();

				if (_this._anyFiltersSet) {
					_this._$resetButton.enable();
					_this._$submitButton.enable();
				} else {
					_this._$resetButton.disable();
					_this._$submitButton.disable();
				}

				_this._$element.triggerHandler('filterschanged.app', { filters: _this._formData });
			});

			this._$resetButton.disable().on('click', function (e) {
				e.preventDefault();

				if (_this._anyFiltersSet) {
					_this._$filters.find(FILTER_INPUTS_SELECTOR).each(function () {
						if ((0, _shim.jQuery)(this).is('select')) {
							(0, _shim.jQuery)(this).val((0, _shim.jQuery)(this).find('option').first().attr('value'));

							if (_shim.jQuery.isFunction((0, _shim.jQuery)(this).selectric)) {
								(0, _shim.jQuery)(this).selectric('refresh');
							}
						} else if ((0, _shim.jQuery)(this).is(':checkbox, :radio')) {
							(0, _shim.jQuery)(this).uncheck().trigger('init.stylableinput');
						} else if ((0, _shim.jQuery)(this).is(':text, textarea')) {
							(0, _shim.jQuery)(this).val('');
						} else {
							(0, _shim.jQuery)(this).val('');
						}
					});

					_this._refreshFilterValues();
					_this._$resetButton.disable();
					// this._$submitButton.enable();
					_this._$element.triggerHandler('filterschanged.app', { filters: _this._formData, reset: true });
					_this._$element.triggerHandler('submitted.app', { filters: _this._formData });
					_this._$submitButton.disable();
				}
			});

			this._$submitButton.disable();

			this._$filterForm.on('submit', function (e) {
				switch (_this._submitMode) {
					case SUBMIT_MODE_SYNC:
						// use browser default behaviour, but keep event from bubbling back to the element resulting in a loop
						e.stopPropagation();
						break;

					case SUBMIT_MODE_ASYNC:
					default:
						e.preventDefault();
						e.stopPropagation();

						_this._$submitButton.disable();

						_this._$element.triggerHandler('submitted.app', { filters: _this._formData });
						break;
				}
			});

			this._$element
			// if a submit is triggered manually by an event on the organism, just submit the form and let its handler deal with it
			.on('submit.app', function () {
				_this._$filterForm.submit();
			})

			// request a "serialized" event containing the current formdata as payload
			.on('serialize.app', function () {
				_this._refreshFilterValues();
				_this._$element.triggerHandler('serialized.app', { filters: _this._formData });
			}).on('updatefilterdata.app', function (e, data) {
				if (_shim.jQuery.isSet(data.count)) {
					var count = parseInt(data.count, 10);

					if (count > 0) {
						_this._$submitButton.text(_shim.jQuery.strFormat(count === 1 ? _this._submitResultCaptionSingularTemplate : _this._submitResultCaptionPluralTemplate, { count: count }));

						if (!data.keepSubmitState) {
							_this._$submitButton.enable();
						}
					} else {
						_this._$submitButton.text(_this._submitNoResultCaptionTemplate);

						if (!data.keepSubmitState) {
							_this._$submitButton.disable();
						}
					}
				} else {
					_this._$submitButton.text(_this._originalSubmitCaption);

					if (!data.keepSubmitState) {
						_this._$submitButton.disable();
					}
				}

				if (_shim.jQuery.isPlainObject(data.filters)) {
					if (data.mode === 'from-scratch') {
						_this._$filters.find('[name]').each(function () {
							var name = (0, _shim.jQuery)(this).attr('name');

							if (!_shim.jQuery.isSet(data.filters[name])) {
								data.filters[name] = '';
							}
						});
					}

					_shim.lodash.each(data.filters, function (value, filterName) {
						_this._$filterForm.find('[name="' + filterName + '"]').each(function () {
							var _this2 = this;

							if ((0, _shim.jQuery)(this).is('select')) {
								var options = _shim.jQuery.isArray(value) ? value : [value],
								    currentVal = (0, _shim.jQuery)(this).val();

								(0, _shim.jQuery)(this).children('option[value!=""]').remove();
								_shim.lodash.each(options, function (option) {
									if (_shim.jQuery.isSet(option.value, option.text)) {
										(0, _shim.jQuery)(_this2).append((0, _shim.jQuery)('<option value="' + option.value + '">' + option.text + '</option>'));
									}
								});

								(0, _dom.waitForRepaint)(function () {
									(0, _shim.jQuery)(_this2).val(currentVal);

									if (_shim.jQuery.isFunction((0, _shim.jQuery)(_this2).selectric)) {
										(0, _shim.jQuery)(_this2).selectric('refresh');

										if (_shim.jQuery.isEmpty((0, _shim.jQuery)(_this2).val())) {
											var $label = (0, _shim.jQuery)(_this2).parent('.selectric-hide-select').siblings('.selectric').find('.label');
											if (!_shim.jQuery.exists($label.children('.default'))) {
												$label.html('<span class="default">' + $label.text() + '</span>');
											}
										}
									}
								});
							} /*if( $(this).is(':checkbox, :radio') ){
         if( !!value ){
         $(this).check().trigger('change');
         } else {
         $(this).uncheck().trigger('change');
         } /*
         } if( $(this).is(':text, textarea') ){
         $(this).val(''+value);
         } else {
         $(this).val(''+value);
         }*/
						});
					});

					(0, _dom.waitForRepaint)(function () {
						_this._refreshFilterValues();
						if (!_this._anyFiltersSet) {
							_this._$resetButton.disable();
						}
					});
				}
			});

			_shim.lodash.defer(function () {
				_this._$element.triggerHandler('initialized.app', { filters: _this._formData });
			});
		}
	}, {
		key: '_refreshFilterValues',
		value: function _refreshFilterValues() {
			this._formData = this._$filterForm.formDataToObject();
			this._cleanFilterValues();
			this._anyFiltersSet = !!_shim.lodash.size(this._formData);
		}
	}, {
		key: '_cleanFilterValues',
		value: function _cleanFilterValues() {
			var formData = {};

			_shim.lodash.each(this._formData, function (value, key) {
				if (_shim.lodash.trim(value) !== '') {
					formData[key] = value;
				}
			});

			this._formData = formData;
		}
	}, {
		key: '_initPatternLabDemoBehaviour',
		value: function _initPatternLabDemoBehaviour() {
			var _this3 = this;

			if ((_context.Context.get('runningInPatternLabList') || _context.Context.get('runningInPatternLabDetails')) && this._$element.parent().closest('[class^="organism-"]').length === 0) {
				this._$element.on('filterschanged.app', function (e, data) {
					if (!data.reset) {
						var emptyFilters = _shim.lodash.random(0, 5) === 0,
						    values = [_shim.lodash.random(10, 99), _shim.lodash.random(10, 99), _shim.lodash.random(10, 99)];

						_this3._$element.triggerHandler('updatefilterdata.app', {
							count: !emptyFilters ? _shim.lodash.random(1, 999) : 0,
							mode: !emptyFilters ? 'additive' : 'from-scratch',
							filters: !emptyFilters ? (0, _defineProperty3.default)({}, 'filter' + _shim.lodash.random(1, 4), [{
								value: values[0],
								text: 'Filter ' + values[0]
							}, {
								value: values[1],
								text: 'Filter ' + values[1] + ' Filter ' + values[1] + ' Filter ' + values[1]
							}, {
								value: values[2],
								text: 'Filter ' + values[2] + ' Filter ' + values[2]
							}]) : {}
						});
					}
				}).on('initialized.app', function (e, data) {
					_shim.jQuery.log('OrganismFilterboxLocations -> initialized.app', data.filters);
				}).on('submitted.app', function (e, data) {
					_shim.jQuery.log('OrganismFilterboxLocations -> submitted.app', data.filters);
				});
			}
		}
	}]);
	return OrganismFilterboxLocations;
}();

function init(app) {
	var $elements = (0, _shim.jQuery)();

	(0, _shim.jQuery)(SELECTOR).each(function () {
		var $this = (0, _shim.jQuery)(this);

		$elements = $elements.add(new OrganismFilterboxLocations(app, $this));
	});

	return $elements;
}

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

exports.init = init;

var _shim = __webpack_require__(2);

var _context = __webpack_require__(37);

var _dom = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NAME = 'organism-filtered-location-list',
    SELECTOR = '.' + NAME;

var OrganismFilteredLocationList = function () {
	function OrganismFilteredLocationList(app, $element) {
		(0, _classCallCheck3.default)(this, OrganismFilteredLocationList);

		if (!_shim.jQuery.isSet($element.dataDuo('primed'))) {
			$element.dataDuo('primed', true);

			this._app = app;
			this._id = _shim.jQuery.randomUuid(true);
			this._$element = $element;

			this._$filterbox = this._$element.find('.filterbox').first();
			this._$locationHolder = this._$element.find('.filtered-locations').first();
			this._$googleMapMolecule = this._$element.find('.molecule-google-map').first();
			this._dataUrl = this._$googleMapMolecule.dataDuo('url');
			this._$map = this._$googleMapMolecule.find('.map-wrapper > .map').first();

			this._locationsInitialCount = _shim.jQuery.isSet(this._$element.data('locations-initial-count')) ? this._$element.data('locations-initial-count') : 12;
			this.ucMapProviderDisabled = window.uc.disabledProviders.SCRIPT ? window.uc.disabledProviders.SCRIPT.find(function (item) {
				return item.pid.includes('S1pcEj_jZX');
			}) : false;

			this._locationTemplate = this._$element.find('.location-template').html();
			this._infoLayerTemplate = this._$element.find('.infolayer-template').html();
			this._locationsUrl = this._$element.data('locations-url');
			_shim.jQuery.assert(_shim.jQuery.isSet(this._locationsUrl, 'OrganismFilteredLocationList.constructor | no locations url has been provided'));
			this._locationsJson = null;
			this._fittingLocations = null;
			this._currentFilterTags = {};

			this._prime();
		}

		return $element;
	}

	(0, _createClass3.default)(OrganismFilteredLocationList, [{
		key: '_prime',
		value: function _prime() {
			var _this = this;

			if (!this.ucMapProviderDisabled) {
				_shim.jQuery.getJSON(this._locationsUrl, function (locationsJson) {
					_shim.jQuery.assert(_shim.jQuery.isArray(locationsJson), 'OrganismFilteredLocationList._prime | locations json must be an array of objects');
					_this._locationsJson = locationsJson;
					_this._fittingLocations = _this._locationsJson;
					_this._refreshFilterTags(_this._locationsJson);
					_this._updateFilterbox(false, true);
					_this._$element.removeClass('loading');
				}).done(function () {
					_shim.jQuery.when(_this._app.loadDynamicDependency('GoogleMapsApi', _this._dataUrl)).done(function () {
						_this._$filterbox.trigger('submit.app');
					});
				});
			} else {
				this._$element.removeClass('loading');
			}

			this._$filterbox.on('filterschanged.app', function (e, data) {
				var filters = data.filters;

				_this._fittingLocations = _shim.lodash.filter(_this._locationsJson, function (location) {
					var res = true;

					_shim.lodash.each(filters, function (filterValue, filterName) {
						if (!_shim.jQuery.isSet(location.filterAttributes) || !_shim.jQuery.isSet(location.filterAttributes[filterName]) || !_shim.jQuery.isSet(location.filterAttributes[filterName].value) && !_shim.jQuery.isArray(location.filterAttributes[filterName].values) || filterValue !== location.filterAttributes[filterName].value && !_shim.lodash.includes(location.filterAttributes[filterName].values, filterValue)) {
							res = false;
							return false;
						}
					});

					return res;
				});

				_this._updateFilterbox(true, false);
			});

			this._$filterbox.on('submitted.app', function () {
				_this._$locationHolder.empty();
				_this._showLocations();

				_this._$element.addClass('filtered');

				_this._refreshFilterTags(_this._fittingLocations);
				_this._updateFilterbox();
			});
		}
	}, {
		key: '_refreshFilterTags',
		value: function _refreshFilterTags(locations) {
			var _this2 = this;

			this._currentFilterTags = {};

			var currentFilterTagsMap = {};

			_shim.lodash.each(locations, function (location) {
				_shim.lodash.each(location.filterAttributes, function (filterTag, filterName) {
					if (!_shim.jQuery.isSet(currentFilterTagsMap[filterName])) {
						currentFilterTagsMap[filterName] = {
							values: [],
							textMap: {}
						};
					}

					if (_shim.jQuery.isSet(filterTag.value, filterTag.text)) {
						currentFilterTagsMap[filterName].values.push(filterTag.value);
						currentFilterTagsMap[filterName].textMap[filterTag.value] = filterTag.text;
					}

					if (_shim.jQuery.isArray(filterTag.values) && _shim.jQuery.isArray(filterTag.texts)) {
						_shim.lodash.each(filterTag.values, function (value, index) {
							currentFilterTagsMap[filterName].values.push(value);
							currentFilterTagsMap[filterName].textMap[value] = filterTag.texts[index];
						});
					}
				});
			});

			_shim.lodash.each(currentFilterTagsMap, function (map, filterName) {
				_shim.lodash.each(_shim.lodash.uniq(map.values), function (value) {
					if (!_shim.jQuery.isSet(_this2._currentFilterTags[filterName])) {
						_this2._currentFilterTags[filterName] = [];
					}

					_this2._currentFilterTags[filterName].push({
						value: value,
						text: map.textMap[value]
					});
				});

				_this2._currentFilterTags[filterName] = _shim.lodash.sortBy(_this2._currentFilterTags[filterName], ['text']);
			});
		}
	}, {
		key: '_updateFilterbox',
		value: function _updateFilterbox(onlyCount, init) {
			if (init) {
				this._$filterbox.triggerHandler('updatefilterdata.app', {
					mode: 'from-scratch',
					filters: this._currentFilterTags
				});
			} else if (onlyCount) {
				this._$filterbox.triggerHandler('updatefilterdata.app', {
					count: _shim.lodash.size(this._fittingLocations)
				});
			} else {
				this._$filterbox.triggerHandler('updatefilterdata.app', {
					count: _shim.lodash.size(this._fittingLocations),
					keepSubmitState: true,
					mode: 'from-scratch',
					filters: this._currentFilterTags
				});
			}
		}
	}, {
		key: '_showLocations',
		value: function _showLocations() {
			var _this3 = this;

			this._$googleMapMolecule.triggerHandler('clear-markers');

			_shim.lodash.each(this._fittingLocations, function (location, index) {
				var $newLocation = (0, _shim.jQuery)(_shim.jQuery.strFormat(_this3._locationTemplate, {
					image_alt: location.image.alt,
					image_desktop: location.image.sources.desktop,
					image_tablet: location.image.sources.tablet,
					image_mobile: location.image.sources.mobile,
					image_default: location.image.sources.default,
					headline: location.headline,
					copytext: location.copytext
				}));

				if (_shim.jQuery.isEmpty(location.copytext)) {
					$newLocation.find('.copytext').remove();
				}

				$newLocation.addClass('preparing');
				_this3._$locationHolder.append($newLocation);
				(0, _dom.waitForRepaint)(function () {
					$newLocation.removeClass('preparing');
				});

				var $newLocationMarker = (0, _shim.jQuery)(_shim.jQuery.strFormat(_this3._infoLayerTemplate, {
					company_name: location.place.companyName,
					street_address: location.place.streetAddress,
					zip_code: location.place.zipCode,
					city: location.place.city,
					phone: location.place.telephone,
					phone_url: 'tel:' + _shim.jQuery.strReplace(' ', '', location.place.telephone),
					fax: location.place.fax,
					fax_url: 'tel:' + _shim.jQuery.strReplace(' ', '', location.place.fax),
					email: location.place.email,
					email_url: 'mailto:' + _shim.jQuery.strReplace(' ', '', location.place.email),
					web_address: location.place.webAddress,
					web_address_url: location.place.webAddress,
					target: true
				}));

				// let markerAddress = location.place.companyName + ' ' + location.place.streetAddress + ' ' + location.place.zipCode + ' ' + location.place.city;
				var markerLatLng = { lat: parseFloat(location.place.position.lat), lng: parseFloat(location.place.position.lng) };
				$newLocationMarker.addClass('preparing');
				_this3._$googleMapMolecule.triggerHandler('add-marker', { location: markerLatLng, html: $newLocationMarker.get(0).outerHTML });
				(0, _dom.waitForRepaint)(function () {
					$newLocationMarker.removeClass('preparing');
				});
			});

			this._$googleMapMolecule.triggerHandler('fit-bounds');
		}
	}]);
	return OrganismFilteredLocationList;
}();

function init(app) {
	var $elements = (0, _shim.jQuery)();

	(0, _shim.jQuery)(SELECTOR).each(function () {
		var $this = (0, _shim.jQuery)(this);

		$elements = $elements.add(new OrganismFilteredLocationList(app, $this));
	});

	return $elements;
}

/***/ })
/******/ ]);